// prettier-ignore
export var redlines = {
  "type": "FeatureCollection",
  "features": [{
    "type": "Feature",
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [[[[-96.856582, 32.762081], [-96.855216, 32.76238], [-96.853255, 32.76278], [-96.851294, 32.76338], [-96.849749, 32.76378], [-96.848204, 32.763979], [-96.847424, 32.763979], [-96.847424, 32.762261], [-96.847959, 32.762351], [-96.848993, 32.76247], [-96.849527, 32.76247], [-96.849064, 32.761031], [-96.850312, 32.760822], [-96.850347, 32.760642], [-96.850169, 32.759952], [-96.850062, 32.759292], [-96.85024, 32.758663], [-96.850597, 32.758063], [-96.850847, 32.757763], [-96.851774, 32.757104], [-96.852415, 32.756744], [-96.853093, 32.756564], [-96.853913, 32.756354], [-96.854804, 32.756174], [-96.855553, 32.755994], [-96.856408, 32.755815], [-96.856551, 32.756204], [-96.856587, 32.756984], [-96.856622, 32.757583], [-96.856658, 32.758273], [-96.856729, 32.758903], [-96.856658, 32.759622], [-96.856622, 32.760462], [-96.856587, 32.761151], [-96.856582, 32.762081]]]]
    },
    "properties": {
      "name": "Oak Cliff",
      "holc_id": "A1",
      "holc_grade": "A",
      "area_description_data": {
        "5": "This is a new subdivision with majority of construction during past five years. It is well laid out, has natural scenic beauty good elevation. type of development and population offsets distance to schools, churches and stores.",
        "6": "Oak Cliff - Dallas, Texas A 1",
        "31": "100",
        "32": "",
        "33": "",
        "1a": "Level to rolling.",
        "1b": "Stevens Park adjoining on South and East. Uniformity of construction. All city conveniences. Scenic beauty. Shuttle bus transportation. Well restricted.",
        "1c": "Some distance to schools, churches and stores. Area joining on North is adjacent to Fort Worth cut off road, a heavy traffic artery lined with filling stations, small stores and tourist camps.",
        "1d": "65",
        "1e": "Static",
        "2a": "Executives, salesmen, business and professional men",
        "2b": "2500-6000",
        "2c": "0 -",
        "2d": "None ",
        "2e": "0",
        "2f": "0",
        "2g": "slowly  ",
        "3a": "1 & 2 story singles 6/8 rooms  ",
        "3b": "Brick & frame  ",
        "3c": "4  ",
        "3d": "Good  ",
        "3e": "95  ",
        "3f": "95  ",
        "3g": "40 to 9500  ",
        "3h": "only few houses  ",
        "3i": "1936 6000-10,500 -    ",
        "3j": "1938 6000-10,500 -    ",
        "3k": "9000 Good  ",
        "3l": "Good  ",
        "3m": "Not sufficient  ",
        "3n": " rental property     ",
        "3o": " to estimate     ",
        "3p": "-  ",
        "3q": "-  ",
        "4a": "Ample",
        "4b": "Ample"
      }
    }
  }, {
    "type": "Feature",
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [[[[-96.821257, 32.880402], [-96.809506, 32.880162], [-96.808993, 32.883084], [-96.808365, 32.887874], [-96.803802, 32.887635], [-96.800094, 32.887587], [-96.797128, 32.887539], [-96.791652, 32.887491], [-96.791537, 32.886533], [-96.791594, 32.885527], [-96.791594, 32.884569], [-96.791709, 32.882078], [-96.794789, 32.882126], [-96.797869, 32.882126], [-96.801634, 32.882222], [-96.803745, 32.882174], [-96.803745, 32.880018], [-96.803859, 32.875946], [-96.801577, 32.875946], [-96.79901, 32.876042], [-96.796557, 32.876186], [-96.796329, 32.874269], [-96.796215, 32.872784], [-96.796158, 32.871347], [-96.796044, 32.870053], [-96.799067, 32.870149], [-96.803859, 32.870005], [-96.803973, 32.865358], [-96.805912, 32.86531], [-96.808764, 32.865262], [-96.810761, 32.865262], [-96.81367, 32.865358], [-96.815381, 32.865406], [-96.817492, 32.865454], [-96.819089, 32.865406], [-96.820572, 32.865454], [-96.82217, 32.866173], [-96.821884, 32.86737], [-96.821713, 32.869574], [-96.821371, 32.87106], [-96.821371, 32.873551], [-96.821257, 32.875611], [-96.821257, 32.878581], [-96.821485, 32.879539], [-96.821257, 32.880402]]]]
    },
    "properties": {
      "name": "Walnut Hills",
      "holc_id": "A10",
      "holc_grade": "A",
      "area_description_data": {
        "5": "This is a highly developed subdivision outside city limits which was particularly designed for expensive suburban homes. That part west highway 116 is of the very highest type containing many of homes in the edifice classification. Some expensive types of cottages in northeastern area.",
        "6": "Walnut Hills, Dallas, Texas A 10",
        "31": "100",
        "32": "",
        "33": "",
        "1a": "Level.",
        "1b": "Uniformity of construction. All city conveniences.",
        "1c": "Lack of transportation, distance to schools, churches and stores, and principal business center, but type of development and population offsets these influences.",
        "1d": "30",
        "1e": "Upward",
        "2a": "Executives, business and professional men, capitalists.",
        "2b": "7500-50,000",
        "2c": "None -",
        "2d": "None ",
        "2e": "None",
        "2f": "None",
        "2g": "Slowly  ",
        "3a": "1 & 2 story singles 6/14 rs.  ",
        "3b": "Brick & stone  ",
        "3c": "5  ",
        "3d": "Good  ",
        "3e": "100  ",
        "3f": "98  ",
        "3g": "40-40,000  ",
        "3h": "-  ",
        "3i": "1936 7500,50,000 -    ",
        "3j": "1938 7500-50,000 -    ",
        "3k": "15,000- Good  ",
        "3l": "Fair  ",
        "3m": "Not sufficient  ",
        "3n": "1936 rental to     ",
        "3o": "1938 warrant estimate     ",
        "3p": "-  ",
        "3q": "-  ",
        "4a": "Ample",
        "4b": "Ample"
      }
    }
  }, {
    "type": "Feature",
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [[[[-96.828778, 32.767117], [-96.828279, 32.766518], [-96.827887, 32.765588], [-96.827637, 32.765079], [-96.827245, 32.764779], [-96.826208, 32.764813], [-96.825791, 32.76455], [-96.825264, 32.764086], [-96.824827, 32.763561], [-96.824663, 32.763364], [-96.825435, 32.762964], [-96.825936, 32.762658], [-96.826089, 32.762565], [-96.826486, 32.761897], [-96.826683, 32.761565], [-96.826762, 32.76125], [-96.826921, 32.760616], [-96.826985, 32.760316], [-96.827116, 32.759695], [-96.827218, 32.759217], [-96.828703, 32.759217], [-96.829654, 32.759067], [-96.831199, 32.758567], [-96.834229, 32.758417], [-96.835893, 32.758417], [-96.836428, 32.758117], [-96.837022, 32.757618], [-96.837319, 32.757168], [-96.837319, 32.756418], [-96.837319, 32.755919], [-96.839102, 32.755869], [-96.841063, 32.755769], [-96.842845, 32.755769], [-96.844628, 32.755819], [-96.846529, 32.756019], [-96.846604, 32.756804], [-96.846604, 32.757194], [-96.846604, 32.757494], [-96.84664, 32.757943], [-96.846925, 32.757913], [-96.847317, 32.757793], [-96.847567, 32.757793], [-96.847424, 32.758393], [-96.847388, 32.758993], [-96.847602, 32.759292], [-96.847602, 32.759682], [-96.847602, 32.759862], [-96.847567, 32.760072], [-96.84721, 32.760342], [-96.846854, 32.760702], [-96.84664, 32.761151], [-96.846212, 32.761481], [-96.846069, 32.761721], [-96.845927, 32.762021], [-96.845677, 32.762351], [-96.845427, 32.7625], [-96.84475, 32.76253], [-96.844215, 32.76256], [-96.843645, 32.76262], [-96.84311, 32.76268], [-96.843035, 32.76373], [-96.842681, 32.763857], [-96.842203, 32.764029], [-96.841613, 32.764305], [-96.841133, 32.764529], [-96.84069, 32.764831], [-96.840301, 32.765095], [-96.839885, 32.765378], [-96.839416, 32.765674], [-96.838935, 32.765978], [-96.838658, 32.766085], [-96.838267, 32.766236], [-96.837904, 32.766375], [-96.837509, 32.766528], [-96.83699, 32.766649], [-96.836439, 32.766777], [-96.835838, 32.766828], [-96.835251, 32.766877], [-96.834653, 32.766835], [-96.833825, 32.766777], [-96.833044, 32.766977], [-96.832458, 32.767127], [-96.831916, 32.767298], [-96.831507, 32.767427], [-96.831151, 32.767777], [-96.830525, 32.767687], [-96.829634, 32.767567], [-96.828778, 32.767117]]]]
    },
    "properties": {
      "name": "Oak Cliff",
      "holc_id": "A2",
      "holc_grade": "A",
      "area_description_data": {
        "5": "This area is well platted, containing rather rigid restrictions, exceptional natural beauty, both in contour and trees, containing several expensive houses, some two or three costing as much as $30,000.",
        "6": "Oak Cliff - Dallas, Texas A 2",
        "31": "100",
        "32": "",
        "33": "",
        "1a": "Rolling.",
        "1b": "Stevens Park joins on west. Wooded lots. Scenic beauty. Uniformity of construction. Shuttle bus transportation in western part. All city conveniences.",
        "1c": "Northeastern part some distance to transportation. Also some distance to schools, churches and stores.",
        "1d": "35",
        "1e": "Static to up",
        "2a": "Clerical, executives, business and professional men",
        "2b": "2500-7500",
        "2c": "None -",
        "2d": "None ",
        "2e": "None",
        "2f": "None",
        "2g": "slowly  ",
        "3a": "1 & 2 story 6/9 room singles  ",
        "3b": "Brick & stone  ",
        "3c": "10  ",
        "3d": "Good  ",
        "3e": "95  ",
        "3f": "95  ",
        "3g": "40 to 10,000  ",
        "3h": "10,000-20,000  ",
        "3i": "1936 6500-15,000 70    ",
        "3j": "1938 6500-15,000 70    ",
        "3k": "to 10,000 fair  ",
        "3l": "fair  ",
        "3m": "Only few houses for rent and these in older part which is southeast part of area. Not sufficient to estimate.  ",
        "3n": " -     ",
        "3o": "      ",
        "3p": "-  ",
        "3q": "-  ",
        "4a": "Ample",
        "4b": "Ample"
      }
    }
  }, {
    "type": "Feature",
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [[[[-96.713212, 32.824434], [-96.711715, 32.823355], [-96.710289, 32.822456], [-96.709219, 32.821557], [-96.708078, 32.820659], [-96.707009, 32.81982], [-96.705939, 32.818861], [-96.70651, 32.818022], [-96.706866, 32.817243], [-96.707294, 32.816464], [-96.70815, 32.815925], [-96.708934, 32.814966], [-96.710146, 32.814007], [-96.710574, 32.813348], [-96.711287, 32.812329], [-96.712998, 32.81155], [-96.71421, 32.810771], [-96.71528, 32.810052], [-96.716421, 32.809153], [-96.71799, 32.808194], [-96.720057, 32.806636], [-96.720842, 32.807115], [-96.72241, 32.808314], [-96.723908, 32.809452], [-96.723266, 32.81137], [-96.722767, 32.812868], [-96.724336, 32.814307], [-96.723836, 32.814726], [-96.72241, 32.815086], [-96.721056, 32.815985], [-96.719986, 32.817063], [-96.718774, 32.818501], [-96.717277, 32.820239], [-96.715922, 32.821737], [-96.714852, 32.822936], [-96.713212, 32.824434]]]]
    },
    "properties": {
      "name": null,
      "holc_id": "A3",
      "holc_grade": "A",
      "area_description_data": {
        "5": "Original developer of this subdivision committed suicide and for a few years activity was slow. However, by reason of deed restrictions, location, type of construction and natural beauty area will remain good, and present building activity will in all probability rapidly increase.",
        "6": "Dallas, Texas A 3",
        "31": "100",
        "32": "",
        "33": "",
        "1a": "Level to rolling",
        "1b": "Near White Rock Lake. Well planned subdivision originally highly restricted. Natural beauty. Bus transportation. Has all city conveniences.",
        "1c": "Outside city limits.",
        "1d": "20",
        "1e": "Static",
        "2a": "Business & professional/ men",
        "2b": "3600-7500",
        "2c": "None -",
        "2d": "None ",
        "2e": "None",
        "2f": "None",
        "2g": "Slowly  ",
        "3a": "Singles 7/10 rooms  ",
        "3b": "Brick & stone  ",
        "3c": "8  ",
        "3d": "Good  ",
        "3e": "98  ",
        "3f": "90  ",
        "3g": "7 to 15,000  ",
        "3h": "9000-30,000  ",
        "3i": "1936 7500-25,000 83    ",
        "3j": "1938 7500-25,000 83    ",
        "3k": "to 15,000 - fair  ",
        "3l": "Fair  ",
        "3m": "75-125  ",
        "3n": "1936 60-100 80    ",
        "3o": "1938 60-100 80    ",
        "3p": "Not sufficient rental property to create demand  ",
        "3q": "  ",
        "4a": "Ample",
        "4b": "Ample"
      }
    }
  }, {
    "type": "Feature",
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [[[[-96.732205, 32.827309], [-96.731849, 32.825611], [-96.731492, 32.824912], [-96.731433, 32.823963], [-96.731076, 32.822865], [-96.730601, 32.820568], [-96.730185, 32.819269], [-96.729769, 32.817971], [-96.729116, 32.815824], [-96.728819, 32.814426], [-96.728937, 32.813527], [-96.729234, 32.812478], [-96.729532, 32.811479], [-96.729532, 32.81038], [-96.730601, 32.809781], [-96.731374, 32.809182], [-96.732443, 32.807983], [-96.733275, 32.807134], [-96.733957, 32.807631], [-96.735058, 32.808433], [-96.736543, 32.809332], [-96.738207, 32.809931], [-96.73993, 32.810131], [-96.740626, 32.810018], [-96.741475, 32.809881], [-96.741831, 32.809731], [-96.742563, 32.810318], [-96.743115, 32.81076], [-96.744387, 32.811779], [-96.744149, 32.813726], [-96.743733, 32.814875], [-96.743852, 32.816123], [-96.74403, 32.816074], [-96.744505, 32.815824], [-96.745337, 32.815075], [-96.748427, 32.814975], [-96.748962, 32.815674], [-96.749318, 32.816074], [-96.750031, 32.816074], [-96.750566, 32.815824], [-96.750982, 32.815225], [-96.751576, 32.814525], [-96.752527, 32.814126], [-96.752512, 32.815149], [-96.752494, 32.816408], [-96.752483, 32.817187], [-96.752464, 32.818506], [-96.752453, 32.819224], [-96.752432, 32.820663], [-96.752408, 32.822315], [-96.742247, 32.822016], [-96.741891, 32.822266], [-96.739039, 32.827758], [-96.734701, 32.825861], [-96.735058, 32.827858], [-96.732205, 32.827309]]]]
    },
    "properties": {
      "name": null,
      "holc_id": "A4",
      "holc_grade": "A",
      "area_description_data": {
        "5": "The area from Gaston Ave. to its Northern point, except about 1 block bordering Abrams Road, is considered one of the highest type residential districts of Dallas, containing several homs costing as much as $60,000. This area is well platted and contains considerable natural beauty. Along Abrams Road and south of Gaston Ave. is desirable but cheaper than remainder of area and not as well platted.",
        "6": "Dallas, Texas A 4",
        "31": "80",
        "32": "20",
        "33": "",
        "1a": "Rolling.",
        "1b": "All city conveniences. Adequate transportation. Overlooks White Rock lake. Golf and country club adjoining. Stores convenient to West side. Adequate restrictions.",
        "1c": "Some distance to schools.",
        "1d": "75",
        "1e": "Static",
        "2a": "Clerical, executives, business and professional men",
        "2b": "2500-25,000",
        "2c": "No -",
        "2d": "No ",
        "2e": "None",
        "2f": "None",
        "2g": "Slowly  ",
        "3a": "1 & 2 story singles 6/10 rooms 1-2 story singes 6/8 rooms ",
        "3b": "Brick & stone Brick & stone ",
        "3c": "10 10 ",
        "3d": "Good Good ",
        "3e": "98 95 ",
        "3f": "95 90 ",
        "3g": "35-12,500 50 to 8000 ",
        "3h": "10,000-45,000 7000,11,000 ",
        "3i": "1936 8500-40,000 87 6500-10,000 92  ",
        "3j": "1938 8500-40,000 87 6500-10,000 92  ",
        "3k": "to 12,500 Good to 8000 Fair ",
        "3l": "Fair Fair ",
        "3m": "80-175 60-90 ",
        "3n": "1936 17-150 90 50-80 86  ",
        "3o": "1938 75-150 90 50-80 86  ",
        "3p": "100- Good 75- Good ",
        "3q": "Poor because of lack of rental units Good ",
        "4a": "Ample",
        "4b": "Ample"
      }
    }
  }, {
    "type": "Feature",
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [[[[-96.755139, 32.813947], [-96.75502, 32.813279], [-96.754925, 32.812749], [-96.754996, 32.812269], [-96.757421, 32.810052], [-96.759132, 32.808314], [-96.760701, 32.807295], [-96.762269, 32.806036], [-96.763624, 32.807295], [-96.764765, 32.808134], [-96.765549, 32.809033], [-96.763981, 32.810291], [-96.762911, 32.81131], [-96.761556, 32.812029], [-96.761057, 32.812629], [-96.760959, 32.813382], [-96.760915, 32.813947], [-96.75956, 32.813827], [-96.758432, 32.813886], [-96.757278, 32.813947], [-96.756422, 32.813947], [-96.755139, 32.813947]]]]
    },
    "properties": {
      "name": null,
      "holc_id": "A5",
      "holc_grade": "A",
      "area_description_data": {
        "5": "This is the last part of a higly restricted addition to be improved, containing structures that could be classed as edifices, occupied by well to do families but on a slight down trend due to younger generation moving in areas of more modern construction.",
        "6": "Dallas, Texas A 5",
        "31": "100",
        "32": "",
        "33": "",
        "1a": "Level to slightly rolling.",
        "1b": "All city conveniences. Adequate transportation. Close to schools, churches, and business center. Uniform type of large, expensive homes.",
        "1c": "Area almost entirely built up. Age of properties.",
        "1d": "95",
        "1e": "Static",
        "2a": "Executives, business and professional men",
        "2b": "4000-25,000",
        "2c": "None -",
        "2d": "None ",
        "2e": "lower income slight",
        "2f": "None",
        "2g": "  Yes",
        "3a": "2 story singles 8/14 rooms  ",
        "3b": "Brick & stone  ",
        "3c": "15  ",
        "3d": "Good  ",
        "3e": "98  ",
        "3f": "90  ",
        "3g": "3 to 15,000  ",
        "3h": "15,000-40,000  ",
        "3i": "1936 9000-25,000 61    ",
        "3j": "1938 9000-25,000 61    ",
        "3k": "Poor  ",
        "3l": "Poor  ",
        "3m": "Not sufficient rental property to establish rental property  ",
        "3n": "1936      ",
        "3o": "      ",
        "3p": "-  ",
        "3q": "-  ",
        "4a": "Ample",
        "4b": "Ample"
      }
    }
  }, {
    "type": "Feature",
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [[[[-96.752493, 32.824323], [-96.755424, 32.824285], [-96.756201, 32.824275], [-96.757492, 32.824275], [-96.759203, 32.824275], [-96.76008, 32.824275], [-96.762019, 32.824275], [-96.763787, 32.824371], [-96.765121, 32.824371], [-96.76612, 32.824371], [-96.767895, 32.824371], [-96.769435, 32.824371], [-96.770192, 32.82439], [-96.77126, 32.824418], [-96.772394, 32.824418], [-96.773371, 32.824418], [-96.774153, 32.824386], [-96.77571, 32.824323], [-96.777683, 32.824352], [-96.778961, 32.824371], [-96.779889, 32.824383], [-96.780961, 32.824398], [-96.782441, 32.824418], [-96.784266, 32.82461], [-96.783296, 32.826432], [-96.783068, 32.827151], [-96.782612, 32.827918], [-96.782041, 32.828828], [-96.781699, 32.829739], [-96.781471, 32.830458], [-96.781129, 32.831321], [-96.780444, 32.831752], [-96.779474, 32.833238], [-96.779246, 32.834053], [-96.778276, 32.835395], [-96.777608, 32.836288], [-96.777307, 32.836689], [-96.773827, 32.836449], [-96.770918, 32.836449], [-96.767781, 32.836449], [-96.764472, 32.836545], [-96.761106, 32.836497], [-96.756258, 32.836402], [-96.752949, 32.836354], [-96.752835, 32.835443], [-96.752721, 32.834149], [-96.752721, 32.831992], [-96.75255, 32.829499], [-96.752379, 32.828637], [-96.752322, 32.827199], [-96.752493, 32.824323]]]]
    },
    "properties": {
      "name": null,
      "holc_id": "A6",
      "holc_grade": "A",
      "area_description_data": {
        "5": "West of Greenville is older part except in Northern border, which is new. Eastern part of area has had much activity in new construction during past few years and it is continuing. This entire area is protected by deed restrictions which have several years yet to run. It will continue to be desirable and sales activity will conmtinue to be good in east portion. All land in thie area has been platted.",
        "6": "Dallas, Texas A 6",
        "31": "85",
        "32": "15",
        "33": "",
        "1a": "Level, rolling.",
        "1b": "Uniformity of construction. Adequate transportation. All city conveniences. Grade schools not far distant. Golf course on east.",
        "1c": "Western portion contains many structures becoming obsolete on account of age.",
        "1d": "70",
        "1e": "Static to upward in eastern part.",
        "2a": "Executive, business and professional men",
        "2b": "2500-7500",
        "2c": "None -",
        "2d": "None ",
        "2e": "None",
        "2f": "None",
        "2g": "Slowly  ",
        "3a": "1 story singles 6/8 rooms 2 story singles 7/9 rooms ",
        "3b": "Brick & stone Brick & stone ",
        "3c": "10 8 ",
        "3d": "Good Good ",
        "3e": "95 95 ",
        "3f": "70 75 ",
        "3g": "60 to 6500 30 to 9000 ",
        "3h": "5000-7500 7500-17,500 ",
        "3i": "1936 4000-6750 85 6000-15,000 83  ",
        "3j": "1938 4000-6750 85 6000-15,000 83  ",
        "3k": "6500- Fair on to new construction 12,500- Good in new construction ",
        "3l": "Fair Fair ",
        "3m": "50-75 65-100 ",
        "3n": "1936 40-65 83 60-90 90  ",
        "3o": "1938 40-65 83 60-90 90  ",
        "3p": "to 60- Good 75- Good ",
        "3q": "Good Good ",
        "4a": "Ample",
        "4b": "Ample"
      }
    }
  }, {
    "type": "Feature",
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [[[[-96.80451, 32.83337], [-96.804481, 32.832582], [-96.802485, 32.832522], [-96.800274, 32.832522], [-96.800274, 32.830665], [-96.800274, 32.829706], [-96.799918, 32.827969], [-96.799419, 32.82689], [-96.798919, 32.825931], [-96.798634, 32.825991], [-96.797636, 32.827669], [-96.797225, 32.827823], [-96.797565, 32.827489], [-96.797921, 32.826591], [-96.798278, 32.825872], [-96.798563, 32.825212], [-96.798991, 32.824074], [-96.798634, 32.823714], [-96.79842, 32.823954], [-96.798349, 32.824493], [-96.798064, 32.825153], [-96.79785, 32.825692], [-96.797493, 32.826231], [-96.797137, 32.826651], [-96.796923, 32.827429], [-96.797117, 32.827863], [-96.796994, 32.827909], [-96.796638, 32.827489], [-96.79678, 32.82671], [-96.797066, 32.825692], [-96.797565, 32.824913], [-96.797707, 32.824014], [-96.79785, 32.823475], [-96.799276, 32.822816], [-96.799846, 32.822276], [-96.799633, 32.821557], [-96.799205, 32.820119], [-96.798706, 32.819101], [-96.798777, 32.818022], [-96.798563, 32.817183], [-96.798206, 32.816524], [-96.797565, 32.815745], [-96.796873, 32.814591], [-96.797114, 32.814118], [-96.797557, 32.813249], [-96.798092, 32.81254], [-96.798641, 32.811811], [-96.798965, 32.811643], [-96.799382, 32.811427], [-96.799839, 32.811139], [-96.800067, 32.810516], [-96.800523, 32.809605], [-96.800923, 32.808934], [-96.801436, 32.808023], [-96.802199, 32.808613], [-96.802919, 32.809365], [-96.802878, 32.80998], [-96.802803, 32.811115], [-96.802717, 32.812426], [-96.802634, 32.81368], [-96.802544, 32.815072], [-96.802463, 32.816317], [-96.802463, 32.817842], [-96.802463, 32.81881], [-96.802474, 32.819642], [-96.80249, 32.820783], [-96.802507, 32.821983], [-96.80252, 32.822932], [-96.803542, 32.822959], [-96.804345, 32.82298], [-96.804345, 32.823268], [-96.805625, 32.823259], [-96.807125, 32.823248], [-96.807909, 32.823243], [-96.809691, 32.82323], [-96.811133, 32.82322], [-96.812476, 32.822233], [-96.813415, 32.821542], [-96.813928, 32.820344], [-96.814909, 32.819586], [-96.816032, 32.820479], [-96.816995, 32.821145], [-96.816811, 32.82311], [-96.816611, 32.825245], [-96.816495, 32.82648], [-96.817204, 32.826984], [-96.818236, 32.827719], [-96.819102, 32.828336], [-96.819861, 32.828876], [-96.819598, 32.830305], [-96.819598, 32.831863], [-96.819434, 32.83315], [-96.81704, 32.83312], [-96.815453, 32.833101], [-96.814201, 32.833048], [-96.812558, 32.832979], [-96.811888, 32.832951], [-96.811282, 32.832921], [-96.809867, 32.832851], [-96.80845, 32.832927], [-96.807075, 32.833001], [-96.807053, 32.834317], [-96.807033, 32.835517], [-96.807015, 32.836595], [-96.805619, 32.836674], [-96.804341, 32.836745], [-96.80444, 32.835695], [-96.804553, 32.834499], [-96.80451, 32.83337]], [[-96.801201, 32.824254], [-96.800702, 32.823535], [-96.800488, 32.823714], [-96.800631, 32.824913], [-96.800845, 32.826171], [-96.801344, 32.82725], [-96.801843, 32.828328], [-96.802271, 32.830006], [-96.802342, 32.831803], [-96.802699, 32.831504], [-96.80277, 32.830545], [-96.802913, 32.829946], [-96.802984, 32.829347], [-96.803126, 32.828867], [-96.803055, 32.828328], [-96.802841, 32.827789], [-96.802556, 32.82719], [-96.802485, 32.82677], [-96.802699, 32.826051], [-96.802627, 32.825692], [-96.801772, 32.825632], [-96.8017, 32.825272], [-96.801486, 32.824973], [-96.801201, 32.824254]], [[-96.799775, 32.823115], [-96.800488, 32.822756], [-96.800987, 32.823115], [-96.801201, 32.822157], [-96.800916, 32.821138], [-96.800417, 32.820299], [-96.799989, 32.8197], [-96.799419, 32.81976], [-96.799989, 32.820718], [-96.800274, 32.821318], [-96.800488, 32.821977], [-96.800132, 32.822516], [-96.799775, 32.823115]], [[-96.798848, 32.815985], [-96.798563, 32.815445], [-96.797921, 32.815685], [-96.798064, 32.816224], [-96.79842, 32.816823], [-96.798706, 32.817483], [-96.798991, 32.818262], [-96.799276, 32.81928], [-96.799775, 32.81928], [-96.799633, 32.818501], [-96.799347, 32.817782], [-96.799205, 32.816883], [-96.798848, 32.815985]], [[-96.802627, 32.809213], [-96.802271, 32.809033], [-96.801772, 32.809512], [-96.801344, 32.810471], [-96.800916, 32.810951], [-96.800631, 32.81155], [-96.800274, 32.812089], [-96.799561, 32.812808], [-96.798919, 32.813468], [-96.798206, 32.814067], [-96.798064, 32.815146], [-96.798563, 32.815086], [-96.798634, 32.814127], [-96.798848, 32.813767], [-96.799347, 32.813168], [-96.799989, 32.812868], [-96.800488, 32.812389], [-96.800916, 32.81191], [-96.8017, 32.81113], [-96.802271, 32.810232], [-96.802627, 32.809213]]]]
    },
    "properties": {
      "name": "Highland Park",
      "holc_id": "A7",
      "holc_grade": "A",
      "area_description_data": {
        "5": "Major portion of this area contains beautiful parkways, ideally landscaped and maintained by promoters of the addition. It has beautiful curving streets and boulevards amply large to care for traffic. Rigidly restricted by deeds that several years yet to run.",
        "6": "Highland Park, Dallas, Texas A 7",
        "31": "70",
        "32": "",
        "33": "",
        "1a": "Level.",
        "1b": "All city conveniences. Adequate transportation. Well planned and highly restricted area. Modern business center in area. Close to schools. Dallas Country Club joins.",
        "1c": "None",
        "1d": "80",
        "1e": "Static to up",
        "2a": "Executives, business, and professional men, capitilist",
        "2b": "5000-30,000",
        "2c": "None -",
        "2d": "None ",
        "2e": "None",
        "2f": "None",
        "2g": "Rapidly  ",
        "3a": "2 story singles 8/14 rooms 1 story singles 6/8 rooms ",
        "3b": "Brick & stone Brick & stone, & hollow tile ",
        "3c": "10 10 ",
        "3d": "Good Good ",
        "3e": "100 100 ",
        "3f": "95 95 ",
        "3g": "40 to 25,000 60 to 12,500 ",
        "3h": "17,000-60,000 7000-15,000 ",
        "3i": "1936 15,000-50,000 86 6500-13,500 91  ",
        "3j": "1938 15,000-50,000 86 6500-13,500 91  ",
        "3k": "to 25,000- Fair to 10,000 Fair ",
        "3l": "Fair Fair ",
        "3m": "Not sufficient Not sufficient ",
        "3n": "1936 rental property  rental property   ",
        "3o": "1938 to estimate  to estimate   ",
        "3p": "- - ",
        "3q": "- - ",
        "4a": "Ample",
        "4b": "Ample"
      }
    }
  }, {
    "type": "Feature",
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [[[[-96.808917, 32.851522], [-96.803391, 32.851372], [-96.796795, 32.851372], [-96.790199, 32.851322], [-96.78949, 32.851332], [-96.789724, 32.849825], [-96.789902, 32.848327], [-96.789902, 32.847279], [-96.789902, 32.845632], [-96.790021, 32.844733], [-96.793051, 32.844783], [-96.795666, 32.844633], [-96.795785, 32.843834], [-96.796841, 32.843805], [-96.797567, 32.843784], [-96.797805, 32.843285], [-96.798565, 32.843302], [-96.799349, 32.843318], [-96.800122, 32.843335], [-96.800538, 32.842786], [-96.800598, 32.841887], [-96.80143, 32.841837], [-96.801474, 32.840866], [-96.80151, 32.840086], [-96.801549, 32.839241], [-96.802499, 32.838742], [-96.80338, 32.838504], [-96.804163, 32.838293], [-96.804269, 32.83737], [-96.804341, 32.836745], [-96.805619, 32.836674], [-96.807015, 32.836595], [-96.807033, 32.835517], [-96.807053, 32.834317], [-96.807075, 32.833001], [-96.80845, 32.832927], [-96.809867, 32.832851], [-96.811282, 32.832921], [-96.811888, 32.832951], [-96.812558, 32.832979], [-96.814201, 32.833048], [-96.815453, 32.833101], [-96.81704, 32.83312], [-96.819434, 32.83315], [-96.819434, 32.834199], [-96.819375, 32.835247], [-96.819493, 32.836146], [-96.821157, 32.836046], [-96.821157, 32.837594], [-96.821395, 32.83989], [-96.821454, 32.841338], [-96.821454, 32.842187], [-96.821335, 32.843585], [-96.821276, 32.845082], [-96.819137, 32.845182], [-96.816344, 32.845332], [-96.813967, 32.845482], [-96.813908, 32.84683], [-96.813611, 32.849226], [-96.813314, 32.850024], [-96.813135, 32.851372], [-96.810996, 32.851372], [-96.808917, 32.851522]]]]
    },
    "properties": {
      "name": "University Park & Highland Park",
      "holc_id": "A8",
      "holc_grade": "A",
      "area_description_data": {
        "5": "10% type above is located in Greenway Parks, one of the most beautifully platted additions in the south. It has beautiful landscaping, restricted to 1 structure per lot. Construction uniform,lot sizes large with beautiful parkways thru center of each block maintained by compulsory taxation. Part of area most likely to decline is south of Mockingbird Lane to railroad. Duplexes and apts. located from Normandy to Larchmont between Preston Road to railroad. Remainder of area uniform and substantial, North-eastern portion of area contains several expensive homes costing as much as 100,000.",
        "6": "University Park & Highland Park A 8",
        "31": "80",
        "32": "10",
        "33": "10",
        "1a": "Level.",
        "1b": "All city conveniences. Adequate transportation. Schools in area. Close to business center. Dallas Country Club joins on Southeast.",
        "1c": "Large number of duplexes in area. Some infiltration of lower grade in part of area south of Mocking Bird lane between St. L. Railroad & Douglas Street.",
        "1d": "60",
        "1e": "Static up.",
        "2a": "Executives, business and professional men capitalists & clerical",
        "2b": "300-25,000",
        "2c": "None -",
        "2d": "- ",
        "2e": "See \"C\" above",
        "2f": "None",
        "2g": "Rapidly  ",
        "3a": "1 & 2 sty singles 6/10 rms. Duplexes 5/6 rms. few apts/ 4/5 rms. Singles 7/14 rms. (See under 5)",
        "3b": "Brick & stone 8 units. Brick & stone Brick & stone",
        "3c": "8 4 6",
        "3d": "Good Good Good",
        "3e": "95 75 98",
        "3f": "85 30 98",
        "3g": "120 to 12500 40 to 15,000 12 to 20,000",
        "3h": "6000-17,500 - -",
        "3i": "1936 5500-15,000 89 7500-17,500 - 15,000-35,000 -",
        "3j": "1938 5500-15,000 89 7500-17,500 - 15,000-35,000 -",
        "3k": "to 10,000 good for new construction Poor Very few for sale practically all result of purchase of vacant lot & erection by owner of house for individual taste",
        "3l": "Fair Poor ",
        "3m": "65-140 - ",
        "3n": "1936 60-125 91 40-70 - Not sufficient rental to warrant estimate ",
        "3o": "1938 60-125 91 40-70 -  ",
        "3p": "to 80- Good to 60- Good ",
        "3q": "Good Good -",
        "4a": "Ample",
        "4b": "Ample"
      }
    }
  }, {
    "type": "Feature",
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [[[[-96.780276, 32.853119], [-96.781702, 32.853069], [-96.782805, 32.853069], [-96.783841, 32.853069], [-96.785229, 32.853069], [-96.786694, 32.853069], [-96.786668, 32.852351], [-96.786634, 32.851372], [-96.787648, 32.851358], [-96.78949, 32.851332], [-96.790199, 32.851322], [-96.796795, 32.851372], [-96.803391, 32.851372], [-96.808917, 32.851522], [-96.808857, 32.855865], [-96.804282, 32.855815], [-96.804341, 32.859359], [-96.801727, 32.860407], [-96.795547, 32.860606], [-96.790496, 32.860606], [-96.783723, 32.860457], [-96.783485, 32.859858], [-96.783188, 32.858011], [-96.781999, 32.857961], [-96.780336, 32.857811], [-96.780157, 32.856214], [-96.780276, 32.855166], [-96.780276, 32.853119]]]]
    },
    "properties": {
      "name": "University Park",
      "holc_id": "A9",
      "holc_grade": "A",
      "area_description_data": {
        "5": "This is an area bordered on all sides by high class residential sections except north which is vacant and future development will be in keeping present area and surroundings. Has deed restrictions.",
        "6": "University Park - Dallas, Texas A 9",
        "31": "60",
        "32": "40",
        "33": "",
        "1a": "Level to rolling.",
        "1b": "School in area. All city conveniences. Fairly convenient to stores and churches. Bus transportation.",
        "1c": "Distance to center of city.",
        "1d": "55",
        "1e": "Static to upward",
        "2a": "Clerical, junior executives business & professional",
        "2b": "2500-7000",
        "2c": "None -",
        "2d": "None ",
        "2e": "None",
        "2f": "None",
        "2g": "Rapidly  ",
        "3a": "Single 6/7 rms. Singles 7/9 rms. ",
        "3b": "Brick & stone Brick & stone ",
        "3c": "8 6 ",
        "3d": "Good Good ",
        "3e": "95 95 ",
        "3f": "80 80 ",
        "3g": "300-6500 100-12,500 ",
        "3h": "- - ",
        "3i": "1936 5500-7000 - 7500-14,000 -  ",
        "3j": "1938 5500-7000 - 7500-14,000 -  ",
        "3k": "6000- Good 10,000- Good ",
        "3l": "Good Good ",
        "3m": "- - ",
        "3n": "1936 50-65 - 65-90 -  ",
        "3o": "1938 50-65 - 65-90 -  ",
        "3p": "to 60 - good to 80 - good ",
        "3q": "Good Good ",
        "4a": "Ample",
        "4b": "Ample"
      }
    }
  }, {
    "type": "Feature",
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [[[[-96.827574, 32.757518], [-96.828287, 32.756418], [-96.828406, 32.755419], [-96.828466, 32.754319], [-96.828585, 32.752321], [-96.830189, 32.752471], [-96.831853, 32.75252], [-96.832982, 32.75287], [-96.832982, 32.755269], [-96.833576, 32.755419], [-96.833576, 32.756668], [-96.835358, 32.756618], [-96.835121, 32.755269], [-96.835358, 32.755219], [-96.835893, 32.755169], [-96.835656, 32.75402], [-96.837735, 32.75392], [-96.838924, 32.75382], [-96.841419, 32.75372], [-96.841419, 32.75312], [-96.842845, 32.751721], [-96.841835, 32.750771], [-96.841776, 32.749222], [-96.841776, 32.747173], [-96.841776, 32.745824], [-96.841776, 32.744025], [-96.842608, 32.744325], [-96.843249, 32.744594], [-96.844271, 32.745024], [-96.845412, 32.745504], [-96.846411, 32.745924], [-96.847668, 32.746385], [-96.848728, 32.746773], [-96.848707, 32.747519], [-96.848691, 32.748068], [-96.848669, 32.748872], [-96.849203, 32.749922], [-96.849108, 32.750781], [-96.849025, 32.751521], [-96.848995, 32.751836], [-96.848884, 32.752982], [-96.848847, 32.75337], [-96.848927, 32.754679], [-96.848966, 32.755319], [-96.84849, 32.755569], [-96.846589, 32.755619], [-96.846529, 32.756019], [-96.844628, 32.755819], [-96.842845, 32.755769], [-96.841063, 32.755769], [-96.839102, 32.755869], [-96.837319, 32.755919], [-96.837319, 32.756418], [-96.837319, 32.757168], [-96.837022, 32.757618], [-96.836428, 32.758117], [-96.835893, 32.758417], [-96.834229, 32.758417], [-96.831199, 32.758567], [-96.829654, 32.759067], [-96.828703, 32.759217], [-96.827218, 32.759217], [-96.826743, 32.759217], [-96.827099, 32.758417], [-96.827574, 32.757518]]]]
    },
    "properties": {
      "name": "Oak Cliff",
      "holc_id": "B1",
      "holc_grade": "B",
      "area_description_data": {
        "5": "North end of Windomere, Edgefirls, Clinton and Winnetka and west end of Neches, 5th & 6th, Salmon Drive, Thomasson, Steward, best streets. South part of western side oldest part of area. Apartment houses located principally along Kings Highway.",
        "6": "Oak Cliff  Dallas, Texas B 1",
        "31": "75",
        "32": "20",
        "33": "5",
        "1a": "Level to rolling.",
        "1b": "Schools and churches in area.Community business center easily accessible. Adequate transportation, except Northern part which is served by Shuttle Bus connecting with street cars which is slightly inconvenient. Area touches municipal gold course on west. Has all city conveniences.",
        "1c": "Private owned amusement park, containing swimming pool, dance pavilian, ball park and picnic grounds. Might be considered of no benefit to area in northern part. Small settlement of negroes also in northern part.",
        "1d": "70",
        "1e": "Static",
        "2a": "Clerical, business executives and professional men",
        "2b": "2000-4000",
        "2c": "None -",
        "2d": "None ",
        "2e": "None",
        "2f": "None",
        "2g": "  Yes",
        "3a": "Singles 5/7 rms. Singles 7/10 rms. Apts 4/12 units 3/5 rms.",
        "3b": "Brick & frame Brick & frame Brick",
        "3c": "15 17 15",
        "3d": "Good Good Good",
        "3e": "95 95 85",
        "3f": "65 60 10",
        "3g": "15 to 6000 None None",
        "3h": "3000-6750 5000-8500 12,500-22,500",
        "3i": "1936 2500-6000 86 4000-7500 84 8000-17,500 71",
        "3j": "1938 2500-6000 86 4000-7500 84 8000-17,500 71",
        "3k": "to 5000 fair to 7000 fair Poor",
        "3l": "Fair Fair Poor",
        "3m": "30-60 40-70 30-50",
        "3n": "1936 25-50 83 35-65 90 25-40 82",
        "3o": "1938 25-50 83 35-65 90 25-40 82",
        "3p": "to 50 - Good to 55 - Fair to 35 - Fair",
        "3q": "Good Fair Fair",
        "4a": "Ample",
        "4b": "Ample"
      }
    }
  }, {
    "type": "Feature",
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [[[[-96.777683, 32.824352], [-96.77571, 32.824323], [-96.774153, 32.824386], [-96.773371, 32.824418], [-96.772394, 32.824418], [-96.77126, 32.824418], [-96.770192, 32.82439], [-96.769435, 32.824371], [-96.767895, 32.824371], [-96.76612, 32.824371], [-96.765121, 32.824371], [-96.763787, 32.824371], [-96.762019, 32.824275], [-96.76008, 32.824275], [-96.759203, 32.824275], [-96.757492, 32.824275], [-96.756201, 32.824275], [-96.755424, 32.824285], [-96.752493, 32.824323], [-96.752408, 32.822315], [-96.752432, 32.820663], [-96.752453, 32.819224], [-96.752464, 32.818506], [-96.752483, 32.817187], [-96.752494, 32.816408], [-96.752512, 32.815149], [-96.752527, 32.814126], [-96.752572, 32.812749], [-96.754426, 32.812928], [-96.754925, 32.812749], [-96.75502, 32.813279], [-96.755139, 32.813947], [-96.756422, 32.813947], [-96.757278, 32.813947], [-96.758432, 32.813886], [-96.75956, 32.813827], [-96.760915, 32.813947], [-96.760959, 32.813382], [-96.761057, 32.812629], [-96.761556, 32.812029], [-96.762911, 32.81131], [-96.763981, 32.810291], [-96.765549, 32.809033], [-96.764765, 32.808134], [-96.763624, 32.807295], [-96.762269, 32.806036], [-96.760821, 32.804859], [-96.761848, 32.804092], [-96.763388, 32.802749], [-96.765157, 32.801598], [-96.766411, 32.800639], [-96.76818, 32.799249], [-96.769663, 32.800256], [-96.771659, 32.802126], [-96.77377, 32.804044], [-96.776451, 32.806345], [-96.772458, 32.809413], [-96.774683, 32.811139], [-96.774626, 32.815694], [-96.777421, 32.815694], [-96.777421, 32.818043], [-96.782612, 32.818091], [-96.783353, 32.818522], [-96.785749, 32.821974], [-96.784266, 32.82461], [-96.782441, 32.824418], [-96.780961, 32.824398], [-96.779889, 32.824383], [-96.778961, 32.824371], [-96.777683, 32.824352]], [[-96.769328, 32.815745], [-96.770754, 32.815685], [-96.77104, 32.813408], [-96.770968, 32.81179], [-96.770897, 32.810531], [-96.770184, 32.810351], [-96.769257, 32.810531], [-96.769257, 32.81125], [-96.769186, 32.813348], [-96.769186, 32.814486], [-96.769328, 32.815745]]]]
    },
    "properties": {
      "name": "Highland Park and University Park",
      "holc_id": "B10",
      "holc_grade": "B",
      "area_description_data": {
        "5": "East of Lindbergh and North border East of Greenville Ave. best part of area. Southwest corner worst part of area. Apartment houses scattered over entire area except from Llano to Richmond between Greenville and Lindbergh with very few West of Greenville Avenue.",
        "6": "Highland Park and University Park Dallas, Texas B 10",
        "31": "70",
        "32": "10",
        "33": "20",
        "1a": "Level to rolling.",
        "1b": "Adequate transportation. Schools, churches and community business center in area. All city conveniences.",
        "1c": "Age of construction and lower grade area to south - some business encroachment. Encroachment of apartment houses.",
        "1d": "95",
        "1e": "Static",
        "2a": "Clerical, business and professional men, skilled mechanics",
        "2b": "1500-10,000",
        "2c": "None -",
        "2d": "None ",
        "2e": "None",
        "2f": "None",
        "2g": "  Yes",
        "3a": "Singles 5/7 rms. Singles 7/12 rms. Apts 4/20 units 3/5 rs.",
        "3b": "Frame & brick Frame & brick Brick",
        "3c": "18 20 15",
        "3d": "Good Good Good",
        "3e": "95 95 85",
        "3f": "75 50 15",
        "3g": "25-4750 None 5 to 17,500",
        "3h": "2250-6500 4250-7500 8000-42,500",
        "3i": "1936 1750-5000 81 3750-6500 87 7000-35,000 85",
        "3j": "1938 1750-5000 81 3750-6500 87 7000-35,000 85",
        "3k": "to 4000-fair to poor Poor None",
        "3l": "Fair Poor None",
        "3m": "25-65 45-70 25-60",
        "3n": "1936 20-55 82 40-60 87 20-50 82",
        "3o": "1938 20-55 82 40-60 87 20-50 82",
        "3p": "to 45 - Good to 50 - fair to 40 - fair",
        "3q": "Good Fair Fair",
        "4a": "Ample",
        "4b": "Ample"
      }
    }
  }, {
    "type": "Feature",
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [[[[-96.802634, 32.81368], [-96.802717, 32.812426], [-96.802803, 32.811115], [-96.802878, 32.80998], [-96.802919, 32.809365], [-96.803832, 32.810276], [-96.805885, 32.80879], [-96.80406, 32.807064], [-96.804231, 32.806201], [-96.808053, 32.80903], [-96.806342, 32.810516], [-96.804802, 32.811811], [-96.806228, 32.813057], [-96.807483, 32.811906], [-96.809821, 32.810181], [-96.813016, 32.812817], [-96.813757, 32.81229], [-96.817351, 32.814831], [-96.817294, 32.816221], [-96.817207, 32.817809], [-96.814909, 32.819586], [-96.813928, 32.820344], [-96.813415, 32.821542], [-96.812476, 32.822233], [-96.811133, 32.82322], [-96.809691, 32.82323], [-96.807909, 32.823243], [-96.807125, 32.823248], [-96.805625, 32.823259], [-96.804345, 32.823268], [-96.804345, 32.82298], [-96.803542, 32.822959], [-96.80252, 32.822932], [-96.802507, 32.821983], [-96.80249, 32.820783], [-96.802474, 32.819642], [-96.802463, 32.81881], [-96.802463, 32.817842], [-96.802463, 32.816317], [-96.802544, 32.815072], [-96.802634, 32.81368]]]]
    },
    "properties": {
      "name": null,
      "holc_id": "B11",
      "holc_grade": "B",
      "area_description_data": {
        "5": "Prescott, Hawthorne & Herschel best streets. Apartment houses and duplexes scattered throughout area. Cheaper area along southwestern line.",
        "6": "Dallas, Texas B 11",
        "31": "70",
        "32": "20",
        "33": "10",
        "1a": "Level.",
        "1b": "Grade School, churches, community business center in area. Adequate transportation. All city conveniences.",
        "1c": "Many apartment houses and duplexes in the area - age of properties. Some unpaved streets. Several boarding and rooming houses in area. Encroachment of business.",
        "1d": "95",
        "1e": "Static",
        "2a": "Clerical, business and professional men and skilled mechanics",
        "2b": "1500-4000",
        "2c": "None ",
        "2d": "None ",
        "2e": "None",
        "2f": "None",
        "2g": "  Yes",
        "3a": "Singles 5/7 rms. Singles and duplexes 5/10 rs. Apts/ 4/20 units 3/5 rs.",
        "3b": "Frame & brick Frame & brick Brick & few frame",
        "3c": "22 20 15",
        "3d": "Good to fair Good to fair Good",
        "3e": "95 90 85",
        "3f": "60 40 15",
        "3g": "None None None",
        "3h": "2500-5500 4500-7500 7500-60,000",
        "3i": "1936 2000-4500 81 3750-6500 87 7000-50,000 88",
        "3j": "1938 2000-4500 81 3750-6500 87 7000-50,000 88",
        "3k": "Poor Poor None",
        "3l": "Poor Poor None",
        "3m": "25-50 40-60 40-75",
        "3n": "1936 20-42.50 83 35-50 85 30-65 81",
        "3o": "1938 20-42.50 83 35-50 85 30-65 81",
        "3p": "to 40 - fair to 40 - fair to 50 - fair",
        "3q": "Fair Fair Fair",
        "4a": "Ample",
        "4b": "Ample"
      }
    }
  }, {
    "type": "Feature",
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [[[[-96.778527, 32.851393], [-96.778313, 32.851153], [-96.775674, 32.851333], [-96.772751, 32.851453], [-96.772537, 32.847739], [-96.772608, 32.845702], [-96.774106, 32.842887], [-96.775389, 32.84073], [-96.776673, 32.838094], [-96.777608, 32.836288], [-96.778276, 32.835395], [-96.779246, 32.834053], [-96.780216, 32.833142], [-96.7813, 32.83228], [-96.782498, 32.830985], [-96.783739, 32.830022], [-96.784722, 32.82926], [-96.785631, 32.828478], [-96.787118, 32.827199], [-96.788373, 32.826], [-96.79037, 32.824227], [-96.791853, 32.823124], [-96.792594, 32.822501], [-96.792968, 32.821873], [-96.793336, 32.821255], [-96.794191, 32.819577], [-96.794933, 32.817947], [-96.795623, 32.816731], [-96.796131, 32.815838], [-96.796873, 32.814591], [-96.797565, 32.815745], [-96.798206, 32.816524], [-96.798563, 32.817183], [-96.798777, 32.818022], [-96.798706, 32.819101], [-96.799205, 32.820119], [-96.799633, 32.821557], [-96.799846, 32.822276], [-96.799276, 32.822816], [-96.79785, 32.823475], [-96.797707, 32.824014], [-96.797565, 32.824913], [-96.797066, 32.825692], [-96.79678, 32.82671], [-96.796638, 32.827489], [-96.796994, 32.827909], [-96.797117, 32.827863], [-96.797137, 32.827909], [-96.797225, 32.827823], [-96.797636, 32.827669], [-96.798634, 32.825991], [-96.798919, 32.825931], [-96.799419, 32.82689], [-96.799918, 32.827969], [-96.800274, 32.829706], [-96.800274, 32.830665], [-96.800274, 32.832522], [-96.799062, 32.832522], [-96.799062, 32.833241], [-96.799062, 32.834439], [-96.799133, 32.835758], [-96.799133, 32.836836], [-96.800346, 32.837016], [-96.800203, 32.838274], [-96.79949, 32.838873], [-96.798848, 32.839712], [-96.798706, 32.840191], [-96.798634, 32.84067], [-96.796852, 32.84061], [-96.79564, 32.84067], [-96.795711, 32.841689], [-96.795782, 32.842647], [-96.795785, 32.843834], [-96.795666, 32.844633], [-96.793051, 32.844783], [-96.790021, 32.844733], [-96.789902, 32.845632], [-96.789902, 32.847279], [-96.789902, 32.848327], [-96.789724, 32.849825], [-96.78949, 32.851332], [-96.787648, 32.851358], [-96.786634, 32.851372], [-96.786668, 32.852351], [-96.786694, 32.853069], [-96.785229, 32.853069], [-96.783841, 32.853069], [-96.782805, 32.853069], [-96.781702, 32.853069], [-96.780276, 32.853119], [-96.779026, 32.852891], [-96.779026, 32.851513], [-96.778527, 32.851393]], [[-96.786869, 32.845523], [-96.78694, 32.843126], [-96.787154, 32.84061], [-96.787012, 32.838693], [-96.78694, 32.836596], [-96.784801, 32.836596], [-96.781307, 32.836536], [-96.781521, 32.837375], [-96.781521, 32.839053], [-96.781807, 32.841209], [-96.781664, 32.843965], [-96.782734, 32.843965], [-96.782947, 32.84684], [-96.786869, 32.84684], [-96.786869, 32.845523]]]]
    },
    "properties": {
      "name": null,
      "holc_id": "B12",
      "holc_grade": "B",
      "area_description_data": {
        "5": "Along Drexel Drive and St. Johns Drive located several large, expensive homes but old. Southern part of area original part of Highland Park and while properties are old they are still desirable. New construction largely North of Southern Methodist University, on East side of area, where several new subdivisions have been opened. Values have quite a tendency to increase in areas and North of Southern Methodist University but it is possible for values to be adversely affected by cheaper construction on the north.",
        "6": "Dallas, Texas B 12",
        "31": "50",
        "32": "40",
        "33": "10",
        "1a": "Level to rolling.",
        "1b": "All city convenience-adequate transportation-schools and stores in area. Churches in area. Southern Methodist University  in area. Dallas Country Club joins on West.",
        "1c": "Distance to Principal business center. Age of properties in Southern part of area.",
        "1d": "80",
        "1e": "Southern part static Northern part possible upward",
        "2a": "Clerical, business and professional men - executives",
        "2b": "2500-15,000",
        "2c": "None -",
        "2d": "None ",
        "2e": "None",
        "2f": "None",
        "2g": "Slowly  ",
        "3a": "Singles 5/7 rs. Singles & Duplexes 5/10 rs. Apts.4/16 units 3/5 rs.",
        "3b": "Brick-few frames Brick-  frames Brick",
        "3c": "15 15 12",
        "3d": "Good Good Good",
        "3e": "95 95 90",
        "3f": "80 60 1",
        "3g": "200-6500 20 to 9500 10-17,500",
        "3h": "5000-12,500 10,000-45,000 15,000-45,000",
        "3i": "1936 3750-9500 76 6000-20,000 52 10,000-30,000 66",
        "3j": "1938 3750-9500 76 6000-20,000 52 10,000-30,000 66",
        "3k": "to 7500- Fair at price Good on new const. to 10,000-Fair at price Poor",
        "3l": "Fair Fair Poor",
        "3m": "50-100 60-200 55-90",
        "3n": "1936 40-75 78 40-130 66 45-75 83",
        "3o": "1938 40-75 78 40-130 66 45-75 83",
        "3p": "to 60 - Good to 75 - Good to 60 - Good",
        "3q": "Good Fair Good",
        "4a": "Ample",
        "4b": "Ample"
      }
    }
  }, {
    "type": "Feature",
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [[[[-96.827105, 32.823604], [-96.826022, 32.822741], [-96.825622, 32.822501], [-96.82471, 32.822022], [-96.823398, 32.821782], [-96.820203, 32.819433], [-96.820203, 32.818906], [-96.82026, 32.818426], [-96.821572, 32.817276], [-96.822656, 32.816269], [-96.823398, 32.81555], [-96.824139, 32.816173], [-96.824881, 32.816796], [-96.825565, 32.81694], [-96.826478, 32.816605], [-96.827448, 32.816269], [-96.828018, 32.816221], [-96.829558, 32.817468], [-96.830699, 32.818474], [-96.831726, 32.819577], [-96.830528, 32.82044], [-96.831498, 32.821398], [-96.831726, 32.821878], [-96.830186, 32.822885], [-96.833608, 32.825713], [-96.832182, 32.826911], [-96.830927, 32.828014], [-96.8303, 32.828541], [-96.829729, 32.828828], [-96.828874, 32.828349], [-96.827219, 32.826863], [-96.828588, 32.825473], [-96.827676, 32.824035], [-96.827105, 32.823604]]]]
    },
    "properties": {
      "name": null,
      "holc_id": "B13",
      "holc_grade": "B",
      "area_description_data": {
        "5": "In southeastern part of this area located two or three large, expensive estates valued as high as $65,000. Remainder of area a nice section uniformly designed and with uniform construction.",
        "6": "Dallas, Texas B 13",
        "31": "100",
        "32": "",
        "33": "",
        "1a": "Level.",
        "1b": "Adequate bus transportation. School in area. All city conveniences. Stores not distant.",
        "1c": "Surrounding area. Small Industrial Area on Southwest.",
        "1d": "60",
        "1e": "Static",
        "2a": "Clerical, business and professional men",
        "2b": "1800-3000",
        "2c": "None -",
        "2d": "None ",
        "2e": "None",
        "2f": "None",
        "2g": "very slow  ",
        "3a": "Singles 5/7 rs.  ",
        "3b": "Brick & Frame  ",
        "3c": "12  ",
        "3d": "Good  ",
        "3e": "95  ",
        "3f": "75  ",
        "3g": "10 to 5000  ",
        "3h": "3500-6500  ",
        "3i": "1936 3250-5500 89    ",
        "3j": "1938 3250-5500 89    ",
        "3k": "to 4500 - Fair  ",
        "3l": "Fair  ",
        "3m": "30-55  ",
        "3n": "1936 25-45 83    ",
        "3o": "1938 25-45 83    ",
        "3p": "to 40 - fair  ",
        "3q": "Fair  ",
        "4a": "Ample",
        "4b": "Ample"
      }
    }
  }, {
    "type": "Feature",
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [[[[-96.863328, 32.835443], [-96.861502, 32.83712], [-96.859962, 32.838271], [-96.85654, 32.840763], [-96.855969, 32.840523], [-96.854486, 32.839948], [-96.853003, 32.839229], [-96.85249, 32.839181], [-96.85152, 32.838654], [-96.850208, 32.837839], [-96.849238, 32.836881], [-96.847755, 32.835635], [-96.846671, 32.834628], [-96.845359, 32.833286], [-96.845758, 32.832951], [-96.846614, 32.832663], [-96.847185, 32.832184], [-96.848154, 32.831369], [-96.849238, 32.830458], [-96.850949, 32.829308], [-96.852832, 32.831177], [-96.853687, 32.831177], [-96.855057, 32.831369], [-96.856597, 32.831704], [-96.858821, 32.83228], [-96.859677, 32.832759], [-96.863328, 32.835443]]]]
    },
    "properties": {
      "name": null,
      "holc_id": "B14",
      "holc_grade": "B",
      "area_description_data": {
        "5": "Aside from the older houses this area is being improved uniformly. Majority of structures conforming with F. H. A. specifications. ",
        "6": "Dallas, Texas B 14",
        "31": "85",
        "32": "15",
        "33": "",
        "1a": "Level.",
        "1b": "School in area. Stores close. Uniformity of construction. New subdivision. Adequate bus transportation.",
        "1c": "Distance to principal business center. Railroad track on Northeast line. Small industrial plants across railroad on Northeast",
        "1d": "35",
        "1e": "Static",
        "2a": "Clerical, skilled mechanics, small merchants",
        "2b": "1500-2500",
        "2c": "None -",
        "2d": "None ",
        "2e": "None",
        "2f": "None",
        "2g": "Slowly  ",
        "3a": "Singles 5/7 r Singles 5/7 r ",
        "3b": "Brick & frame Brick & frame ",
        "3c": "2 10 ",
        "3d": "Good Good ",
        "3e": "95 95 ",
        "3f": "90 80 ",
        "3g": "50 - 4500 None ",
        "3h": "- 2500-5000 ",
        "3i": "1936 - - 2250-4500 90  ",
        "3j": "1938 3250-4500 - 2250-4500 90  ",
        "3k": "to 4500 - Fair to 4000 - Fair at price ",
        "3l": "Fair Fair ",
        "3m": "Not sufficiently 22.50-45 ",
        "3n": "1936 rented to warrant  20-40 90  ",
        "3o": "1938 an estimate  20-40 90  ",
        "3p": "- to 30 - Fair ",
        "3q": "- Fair ",
        "4a": "Ample",
        "4b": "Ample"
      }
    }
  }, {
    "type": "Feature",
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [[[[-96.839826, 32.850971], [-96.840282, 32.85629], [-96.837202, 32.858973], [-96.836517, 32.85974], [-96.83532, 32.860411], [-96.834407, 32.861752], [-96.831783, 32.861752], [-96.829786, 32.859979], [-96.827847, 32.858111], [-96.827676, 32.857248], [-96.827334, 32.856913], [-96.827505, 32.85605], [-96.827505, 32.850971], [-96.839826, 32.850971]]]]
    },
    "properties": {
      "name": null,
      "holc_id": "B15",
      "holc_grade": "B",
      "area_description_data": {
        "5": "A subdivision platted several years ago that experienced rapid growth for a short time only, retarded due to sitance from center of city and economic conditions. it is attractively designed containing many lots of natural beauty. Very little rental property in the area.",
        "6": "Dallas, Texas B 15",
        "31": "90",
        "32": "10",
        "33": "",
        "1a": "Level.",
        "1b": "Attractive design of subdivision - large lots - attractive contour. All city conveniences. Fair building restrictions.",
        "1c": "Outside city limits. Some distance to stores and school but bus pickup for school children. Transportation inadequate.",
        "1d": "40",
        "1e": "Static to slightly upward",
        "2a": "Clerical, business and professional men merchants",
        "2b": "2000-3600",
        "2c": "None -",
        "2d": "None ",
        "2e": "None",
        "2f": "None",
        "2g": "Slowly  ",
        "3a": "1 sty. singles 6/7 rs/ 2 sty.singles 7/9 rs. ",
        "3b": "Brick & frame Brick & frame ",
        "3c": "12 12 ",
        "3d": "Good Good ",
        "3e": "98 98 ",
        "3f": "90 90 ",
        "3g": "8 to 5000 None ",
        "3h": "4000-7000 5000-7000 ",
        "3i": "1936 3500-6500 90 4750-7000 98  ",
        "3j": "1938 3500-6500 90 4750-7000 98  ",
        "3k": "to 6000 Fair Poor ",
        "3l": "Fair Poor ",
        "3m": "35-55 45-65 ",
        "3n": "1936 30-50 88 40-60 90  ",
        "3o": "1938 30-50 88 40-60 90  ",
        "3p": "to 40 Fair because of inadequate transportation Poor ",
        "3q": "Fair Poor ",
        "4a": "Ample",
        "4b": "Ample"
      }
    }
  }, {
    "type": "Feature",
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [[[[-96.858413, 32.75312], [-96.857787, 32.753446], [-96.856646, 32.753566], [-96.855362, 32.753686], [-96.854507, 32.753786], [-96.854459, 32.754305], [-96.854626, 32.755085], [-96.854016, 32.755169], [-96.85366, 32.75277], [-96.85366, 32.750022], [-96.855621, 32.749472], [-96.856393, 32.746773], [-96.856453, 32.744774], [-96.856809, 32.743525], [-96.85669, 32.741826], [-96.860493, 32.741976], [-96.863939, 32.742026], [-96.866019, 32.742075], [-96.867921, 32.742175], [-96.86798, 32.743425], [-96.868039, 32.744574], [-96.866792, 32.745124], [-96.865544, 32.745824], [-96.864593, 32.746224], [-96.863108, 32.746673], [-96.861919, 32.747023], [-96.859661, 32.747573], [-96.85877, 32.747573], [-96.85877, 32.749572], [-96.858413, 32.75312]]]]
    },
    "properties": {
      "name": "Oak Cliff",
      "holc_id": "B2",
      "holc_grade": "B",
      "area_description_data": {
        "5": "A fairly well balanced neighborhood, largely new and with fair prospects for some further development. Southern part of area north of Jefferson is very active now with new construction, and Western part of area south of Jefferson also very active.",
        "6": "Oak Cliff - Dallas, Texas B 2",
        "31": "80",
        "32": "20",
        "33": "",
        "1a": "Level to rolling.",
        "1b": "Small park playground in area. Good Senior High School joins on east. Major portion of area comparatively new. Southwestern part some distance from stores.",
        "1c": "Shuttle Bus transportation along Jefferson somewhat inconvenient. Distance to principal business center.",
        "1d": "40",
        "1e": "Static to upward",
        "2a": "Clerical, business and professional men",
        "2b": "1800-3000",
        "2c": "None -",
        "2d": "None ",
        "2e": "None",
        "2f": "None",
        "2g": "Slightly  ",
        "3a": "Singles 5/7 rms. Singles 5/6 rms. ",
        "3b": "Brick Brick ",
        "3c": "2 10 ",
        "3d": "Good Good ",
        "3e": "95 95 ",
        "3f": "80 80 ",
        "3g": "60-4,750 None ",
        "3h": "- 4000-5000 ",
        "3i": "1936 4250-5000 - 3250-4500 86  ",
        "3j": "1938 4250-5000 - 3250-4500 86  ",
        "3k": "to 4500 fair to 4000 fair ",
        "3l": "Fair Fair ",
        "3m": "- 35-50 ",
        "3n": "1936 - - 32.50-45 91  ",
        "3o": "1938 37.50-45 - 32.5 91  ",
        "3p": "to 45 fair to 40 fair ",
        "3q": "Fair fair ",
        "4a": "Ample",
        "4b": "Ample"
      }
    }
  }, {
    "type": "Feature",
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [[[[-96.86905, 32.733929], [-96.867683, 32.734228], [-96.866613, 32.734278], [-96.865425, 32.734278], [-96.864296, 32.734428], [-96.863226, 32.734428], [-96.861681, 32.734428], [-96.860671, 32.734428], [-96.859245, 32.734328], [-96.857344, 32.734378], [-96.856096, 32.734428], [-96.855145, 32.734378], [-96.854254, 32.734278], [-96.853482, 32.734278], [-96.8536, 32.731879], [-96.85366, 32.73013], [-96.853719, 32.72888], [-96.853719, 32.72783], [-96.854254, 32.72773], [-96.856571, 32.72768], [-96.857284, 32.72748], [-96.859008, 32.72733], [-96.860374, 32.727281], [-96.862097, 32.727281], [-96.864771, 32.72738], [-96.865603, 32.72733], [-96.86691, 32.72733], [-96.867623, 32.72743], [-96.868218, 32.727281], [-96.86905, 32.727131], [-96.86905, 32.733929]]]]
    },
    "properties": {
      "name": "Oak Cliff",
      "holc_id": "B3",
      "holc_grade": "B",
      "area_description_data": {
        "5": "Best part of area is East of Superior Street. A well established area of small brick and frame cottages, well occupied, and evidencing pride of ownership.",
        "6": "Oak Cliff  Dallas, Texas B 3",
        "31": "100",
        "32": "",
        "33": "",
        "1a": "Level.",
        "1b": "Adequate transportation. All city conveniences. Community business center in area.",
        "1c": "Some distance to city grade and high schools. Distance to principal business center. Poor approach to main business district. Surrounded on two sides by cheaper properties. Unpaved streets.",
        "1d": "85",
        "1e": "Static",
        "2a": "Clerical, business, and professional men",
        "2b": "1800-3000",
        "2c": "None -",
        "2d": "No ",
        "2e": "None",
        "2f": "None",
        "2g": "  Yes",
        "3a": "Singles 5/7 rms.  ",
        "3b": "Brick - some frame  ",
        "3c": "12  ",
        "3d": "Good  ",
        "3e": "95  ",
        "3f": "75  ",
        "3g": "10 to 4500  ",
        "3h": "4250-5500  ",
        "3i": "1936 3759-4500 85    ",
        "3j": "1938 3750-4500 85    ",
        "3k": "to 4000 fair  ",
        "3l": "fair  ",
        "3m": "35-50  ",
        "3n": "1936 32.50-45 91    ",
        "3o": "1938 32.50-45 91    ",
        "3p": "to 40 - good  ",
        "3q": "Good  ",
        "4a": "Ample",
        "4b": "Ample"
      }
    }
  }, {
    "type": "Feature",
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [[[[-96.840231, 32.726231], [-96.841128, 32.726242], [-96.842079, 32.726255], [-96.84297, 32.726266], [-96.844093, 32.726281], [-96.844186, 32.726751], [-96.844271, 32.727181], [-96.844248, 32.727603], [-96.844212, 32.72823], [-96.844212, 32.72923], [-96.844212, 32.73028], [-96.844153, 32.731529], [-96.843235, 32.731844], [-96.842548, 32.732079], [-96.841479, 32.732379], [-96.840231, 32.732779], [-96.840231, 32.726231]]]]
    },
    "properties": {
      "name": "Oak Cliff",
      "holc_id": "B4",
      "holc_grade": "B",
      "area_description_data": {
        "5": "A small well balanced area, containing a better type of improvements than surrounding area.",
        "6": "Oak Cliff   Dallas, Texas B 4",
        "31": "100",
        "32": "",
        "33": "",
        "1a": "Rolling.",
        "1b": "Uniformity of construction. Conveniently located to school. Good approach. Bus transportation. All city conveniences.",
        "1c": "Distance from center of city. Unproved area on west. No restrictions except zoning.",
        "1d": "90",
        "1e": "Static",
        "2a": "Clerical some business and professional men",
        "2b": "1800-3000",
        "2c": "None -",
        "2d": "None ",
        "2e": "None",
        "2f": "None",
        "2g": "  Yes",
        "3a": "Singles 5/7 rms.  ",
        "3b": "Brick & some frame  ",
        "3c": "12  ",
        "3d": "Good  ",
        "3e": "95  ",
        "3f": "80  ",
        "3g": "12 to 4250  ",
        "3h": "3000 to 5000  ",
        "3i": "1936 2500-4500 87    ",
        "3j": "1938 2500-4500 87    ",
        "3k": "to 4000 fair  ",
        "3l": "Fair  ",
        "3m": "30-50  ",
        "3n": "1936 25-42.50 84    ",
        "3o": "1938 25-42.50 84    ",
        "3p": "to 40 - fair  ",
        "3q": "Fair  ",
        "4a": "Ample",
        "4b": "Ample"
      }
    }
  }, {
    "type": "Feature",
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [[[[-96.813433, 32.716683], [-96.814086, 32.716583], [-96.816047, 32.718782], [-96.817414, 32.720132], [-96.82086, 32.720132], [-96.823296, 32.720182], [-96.825435, 32.720282], [-96.828822, 32.720332], [-96.83114, 32.720332], [-96.83114, 32.721332], [-96.830664, 32.722182], [-96.83007, 32.723131], [-96.829595, 32.723881], [-96.829654, 32.724831], [-96.829476, 32.725181], [-96.828347, 32.726231], [-96.827693, 32.727081], [-96.827337, 32.72778], [-96.827159, 32.72838], [-96.826921, 32.72888], [-96.826208, 32.72993], [-96.825851, 32.73053], [-96.825019, 32.731129], [-96.82389, 32.731479], [-96.822821, 32.731479], [-96.822821, 32.732279], [-96.822643, 32.733229], [-96.821811, 32.733529], [-96.821357, 32.733895], [-96.820873, 32.734286], [-96.820325, 32.734728], [-96.819669, 32.735211], [-96.819553, 32.73003], [-96.817532, 32.73003], [-96.814859, 32.73008], [-96.813314, 32.73003], [-96.813314, 32.72873], [-96.813135, 32.726431], [-96.813076, 32.724331], [-96.813195, 32.722382], [-96.813314, 32.721132], [-96.813373, 32.718682], [-96.813433, 32.716683]]]]
    },
    "properties": {
      "name": "Oak Cliff",
      "holc_id": "B5",
      "holc_grade": "B",
      "area_description_data": {
        "5": "Northern part east of Beckley better part of area. Higher priced new construction north of Vermont and between Marsalis & Ramsey. Cheaper new construction is west of Beckley. On Beckley at Iowa & Georgia bordering street car line is worst part of area.",
        "6": "Oak Cliff    Dallas Texas B 5",
        "31": "80",
        "32": "15",
        "33": "5",
        "1a": "Rolling, level.",
        "1b": "Has all city conveniences, schools, churches and stores in area. Bus transportation.",
        "1c": "Distance to principal business center. Unpaved streets. Interurban line through part of area.",
        "1d": "80",
        "1e": "Static",
        "2a": "Clerical, skilled mechanics small merchants",
        "2b": "1500-2500",
        "2c": "None ",
        "2d": "No ",
        "2e": "None",
        "2f": "None",
        "2g": "Slowly  ",
        "3a": "Singles 5/6 rms. Singles 5/7 rms. Singles 3/4 rms.",
        "3b": "Frame Brick Frame",
        "3c": "12 12 15",
        "3d": "Good Good Fair",
        "3e": "95 95 90",
        "3f": "65 75 80",
        "3g": "70 to 4000 30 to 4500 None",
        "3h": "2250-4500 4500-6000 1250-2250",
        "3i": "1936 1750-3750 81 3750-5000 83 1000-1750 79",
        "3j": "1938 1750-3750 81 3750-5000 83 1000-1750 79",
        "3k": "to 3500 poor to 4500 poor None",
        "3l": "Poor Poor None",
        "3m": "22.50-45 40-55 15-22.50",
        "3n": "1936 17.50-37.50 81 35-47.50 87 12.50-18 82",
        "3o": "1938 17.50-37.50 81 35-47.50 87 12.50-18 82",
        "3p": "to 35 - fair to 45 - fair to 15 - fair",
        "3q": "Fair Fair Fair",
        "4a": "Ample",
        "4b": "Ample"
      }
    }
  }, {
    "type": "Feature",
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [[[[-96.79008, 32.726981], [-96.791685, 32.726331], [-96.792517, 32.725931], [-96.793289, 32.725331], [-96.794359, 32.724981], [-96.795309, 32.724481], [-96.796498, 32.723981], [-96.797805, 32.723481], [-96.798696, 32.723281], [-96.799885, 32.725181], [-96.80042, 32.726131], [-96.800954, 32.72773], [-96.799231, 32.72858], [-96.798162, 32.72908], [-96.79733, 32.72953], [-96.79632, 32.73003], [-96.795309, 32.73043], [-96.79418, 32.73073], [-96.793705, 32.731029], [-96.793051, 32.731279], [-96.792695, 32.731179], [-96.79222, 32.72943], [-96.791507, 32.72878], [-96.791031, 32.72788], [-96.79008, 32.726981]]]]
    },
    "properties": {
      "name": "Oak Cliff",
      "holc_id": "B6",
      "holc_grade": "B",
      "area_description_data": {
        "5": "A fairly uniform area started about 11 years ago but because of lack of promotional ability of subdividers, activity past few years has been almost dead.",
        "6": "Oak Cliff   Dallas, Texas B 6",
        "31": "100",
        "32": "",
        "33": "",
        "1a": "Rolling.",
        "1b": "Uniformity of construction. Country Club and Golf Course joins on South. Has all city conveniences. High elevation.",
        "1c": "Lack of adequate transportation. Distance to schools and churches and community business center. Loss of activity in subdivision. ",
        "1d": "30",
        "1e": "Static",
        "2a": "Clerical and small merchants",
        "2b": "1800-3000",
        "2c": "None -",
        "2d": "None ",
        "2e": "None",
        "2f": "None",
        "2g": "  Yes",
        "3a": "Singles 5/7 rms.  ",
        "3b": "Brick & some frame  ",
        "3c": "10  ",
        "3d": "Good  ",
        "3e": "95  ",
        "3f": "80  ",
        "3g": "4 to 4500  ",
        "3h": "4250-5500  ",
        "3i": "1936 3750-4750 87    ",
        "3j": "1938 3750-4750 87    ",
        "3k": "to 4500 - poor  ",
        "3l": "Poor  ",
        "3m": "40- 50  ",
        "3n": "1936 35-45 89    ",
        "3o": "1938 35-45 89    ",
        "3p": "to 45 - fair  ",
        "3q": "Fair  ",
        "4a": "Ample",
        "4b": "Ample"
      }
    }
  }, {
    "type": "Feature",
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [[[[-96.717602, 32.778273], [-96.716508, 32.777913], [-96.715367, 32.777473], [-96.713609, 32.776834], [-96.712087, 32.776314], [-96.711089, 32.775915], [-96.710138, 32.775395], [-96.709806, 32.774995], [-96.710138, 32.774076], [-96.710376, 32.773397], [-96.710661, 32.772837], [-96.710614, 32.772118], [-96.710566, 32.771398], [-96.710519, 32.770319], [-96.711089, 32.769919], [-96.711327, 32.76936], [-96.71185, 32.76876], [-96.712135, 32.7682], [-96.712373, 32.767361], [-96.712896, 32.766721], [-96.713704, 32.765642], [-96.714274, 32.764803], [-96.714987, 32.764963], [-96.715653, 32.765322], [-96.716461, 32.765562], [-96.717506, 32.765642], [-96.718315, 32.765722], [-96.71898, 32.765802], [-96.719741, 32.765882], [-96.719551, 32.766682], [-96.719455, 32.768041], [-96.719693, 32.76864], [-96.719551, 32.76924], [-96.71917, 32.769759], [-96.718933, 32.771358], [-96.719218, 32.771478], [-96.720073, 32.771478], [-96.721167, 32.771438], [-96.722117, 32.771438], [-96.722973, 32.771478], [-96.724019, 32.771598], [-96.723258, 32.772437], [-96.722545, 32.773157], [-96.7215, 32.774236], [-96.720882, 32.774676], [-96.720264, 32.775635], [-96.719788, 32.776274], [-96.71936, 32.776834], [-96.718647, 32.777633], [-96.718315, 32.778073], [-96.717602, 32.778273]]]]
    },
    "properties": {
      "name": null,
      "holc_id": "B7",
      "holc_grade": "B",
      "area_description_data": {
        "5": "This is a new subdivision with only about 20 homes in it. It is owned by one of the large banks in Dallas and is now being pushed by it. It is frequently advertised in in the newspapers, and efforts to create sales demand are meeting with some success due to new construction of modern design and ultra convenient arrangements.",
        "6": "Dallas, Texas B 7",
        "31": "100",
        "32": "",
        "33": "",
        "1a": "Level to rolling.",
        "1b": "High elevation. Golf course joining. New subdivision. Has all city conveniences.",
        "1c": "Outside city limits and distance to principal business center. Poor transportation.",
        "1d": "10",
        "1e": "Static",
        "2a": "Clerical Small merchants",
        "2b": "1800-2500",
        "2c": "None -",
        "2d": "None ",
        "2e": "None",
        "2f": "None",
        "2g": "Slowly  ",
        "3a": "Singles 5/7 rms.  ",
        "3b": "Brick & frame  ",
        "3c": "5  ",
        "3d": "Good  ",
        "3e": "95  ",
        "3f": "90  ",
        "3g": "6 to 4000  ",
        "3h": "-  ",
        "3i": "1936 3000-4000 -    ",
        "3j": "1938 3000-4000 -    ",
        "3k": "to 3500 fair  ",
        "3l": "Fair  ",
        "3m": "-  ",
        "3n": "1936 27.50-30 -    ",
        "3o": "1938 27.50-30 -    ",
        "3p": "to 30 Fair  ",
        "3q": "Fair  ",
        "4a": "Ample",
        "4b": "Ample"
      }
    }
  }, {
    "type": "Feature",
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [[[[-96.732756, 32.790522], [-96.733041, 32.78774], [-96.737148, 32.787884], [-96.737148, 32.787549], [-96.737148, 32.785343], [-96.737148, 32.785007], [-96.737262, 32.784383], [-96.739943, 32.784383], [-96.744108, 32.784383], [-96.744108, 32.784719], [-96.744108, 32.786685], [-96.744051, 32.789946], [-96.743936, 32.791529], [-96.743936, 32.791864], [-96.743936, 32.792823], [-96.743936, 32.793159], [-96.740115, 32.793159], [-96.736065, 32.793207], [-96.733783, 32.793255], [-96.732243, 32.793255], [-96.732585, 32.791864], [-96.732756, 32.790522]]]]
    },
    "properties": {
      "name": null,
      "holc_id": "B8",
      "holc_grade": "B",
      "area_description_data": {
        "5": "Just a fair area, mixed type of construction, lower grade area bordering on South and West and undeveloped land in East.",
        "6": "Dallas, Texas B 8",
        "31": "95",
        "32": "5",
        "33": "",
        "1a": "Level to rolling.",
        "1b": "All city conveniences. Park joins on North. Western part of area has adequate transportation and fairly convenient to stores schools.",
        "1c": "Inadequate transportation in Eastern part as street car line stops at BeemanAve. Schools not very close - Community business on East Grand which is some distance from Eastern part of area.",
        "1d": "40",
        "1e": "Static",
        "2a": "Clerical, Mechanics & Merchants",
        "2b": "1500-3000",
        "2c": "None -",
        "2d": "None ",
        "2e": "None",
        "2f": "None",
        "2g": "Very slow  ",
        "3a": "1 sty.singles 5/7 rms. 2 sty.singles 6/8 rms. ",
        "3b": "Brick & frame Brick ",
        "3c": "14 14 ",
        "3d": "Good Good ",
        "3e": "95 95 ",
        "3f": "60 70 ",
        "3g": "25 to 4000 None ",
        "3h": "2250-5000 4000-7000 ",
        "3i": "1936 1750-4500 84 3750-5750 88  ",
        "3j": "1938 1750-4500 84 3750-5750 88  ",
        "3k": "to 4500 Poor to 5000 Poor ",
        "3l": "Poor Poor ",
        "3m": "22.50-50 40-65 ",
        "3n": "1936 17.50-45 84 37.50-55 89  ",
        "3o": "1938 17.50-45 84 37.50-55 89  ",
        "3p": "to 40 Fair to 45 Fair ",
        "3q": "Fair Fair ",
        "4a": "Ample",
        "4b": "Ample"
      }
    }
  }, {
    "type": "Feature",
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [[[[-96.751003, 32.812329], [-96.750005, 32.812089], [-96.749078, 32.812089], [-96.748579, 32.81155], [-96.747866, 32.810951], [-96.746939, 32.810291], [-96.744942, 32.809213], [-96.743115, 32.81076], [-96.742563, 32.810318], [-96.741831, 32.809731], [-96.741475, 32.809881], [-96.740626, 32.810018], [-96.73993, 32.810131], [-96.738207, 32.809931], [-96.736543, 32.809332], [-96.735058, 32.808433], [-96.733957, 32.807631], [-96.733275, 32.807134], [-96.73332, 32.806336], [-96.733748, 32.805797], [-96.734817, 32.805078], [-96.73553, 32.804298], [-96.736671, 32.80328], [-96.737598, 32.802381], [-96.739024, 32.801062], [-96.739715, 32.800304], [-96.74, 32.800735], [-96.741141, 32.801359], [-96.74251, 32.801598], [-96.74348, 32.802557], [-96.744279, 32.803133], [-96.746332, 32.804955], [-96.746789, 32.804811], [-96.747815, 32.805578], [-96.750268, 32.807256], [-96.75255, 32.805434], [-96.754718, 32.803612], [-96.757304, 32.801881], [-96.757522, 32.802071], [-96.758026, 32.802509], [-96.75854, 32.802895], [-96.759623, 32.803708], [-96.760821, 32.804859], [-96.762269, 32.806036], [-96.760701, 32.807295], [-96.759132, 32.808314], [-96.757421, 32.810052], [-96.754996, 32.812269], [-96.754925, 32.812749], [-96.754426, 32.812928], [-96.752572, 32.812749], [-96.751003, 32.812329]]]]
    },
    "properties": {
      "name": null,
      "holc_id": "B9",
      "holc_grade": "B",
      "area_description_data": {
        "5": "Northeastern part has most of smaller places and new construction. Apartments mostly on Reiger, Victor, Tremont & Worth. Monto Vista, Newell, Clermont, best streets.",
        "6": "Dallas, Texas B 9",
        "31": "70",
        "32": "20",
        "33": "10",
        "1a": "Level to rolling.",
        "1b": "Adequate transportation. Grade school in area. Country Club and one small part and one large park join area. Community business center in area.",
        "1c": "Heavy traffic on Gaston Avenue. Age of majority of improvements. Encroachment of apartment houses.",
        "1d": "80",
        "1e": "Static slowly up in Northeast",
        "2a": "Executives, business and professional men, clerical",
        "2b": "2000-6000",
        "2c": "None -",
        "2d": "None ",
        "2e": "None",
        "2f": "None",
        "2g": "Slowly  ",
        "3a": "Singles 6/7 rms. Singles 7/12 rms. Apts 4/20 units 3/5 rs.",
        "3b": "Brick & frame Brick & frame Brick",
        "3c": "15 20 13",
        "3d": "Good Good Good",
        "3e": "95 95 90",
        "3f": "65 50 10",
        "3g": "45 - 5000 None None",
        "3h": "3250-6000 4500-9500 10,000-35,000",
        "3i": "1936 2750-5000 84 3750-7500 81 8000-25,000 76",
        "3j": "1938 2750-5000 84 3750-7500 81 8000-25,000 76",
        "3k": "to 4500 Poor 6000- Poor None",
        "3l": "Poor Poor None",
        "3m": "35-60 42.50-75 25-55",
        "3n": "1936 30-50 85 35-65 85 20-45 81",
        "3o": "1938 30-50 85 35-65 85 20-45 81",
        "3p": "to 45 Good to 50 Fair to 40 Fair",
        "3q": "Good Fair Fair",
        "4a": "Ample",
        "4b": "Ample"
      }
    }
  }, {
    "type": "Feature",
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [[[[-96.831091, 32.771524], [-96.831151, 32.767777], [-96.831507, 32.767427], [-96.831916, 32.767298], [-96.832458, 32.767127], [-96.833044, 32.766977], [-96.833825, 32.766777], [-96.834653, 32.766835], [-96.835251, 32.766877], [-96.835838, 32.766828], [-96.836439, 32.766777], [-96.83699, 32.766649], [-96.837509, 32.766528], [-96.837904, 32.766375], [-96.838267, 32.766236], [-96.838658, 32.766085], [-96.838935, 32.765978], [-96.839416, 32.765674], [-96.839885, 32.765378], [-96.840301, 32.765095], [-96.84069, 32.764831], [-96.841133, 32.764529], [-96.841613, 32.764305], [-96.842203, 32.764029], [-96.842681, 32.763857], [-96.843035, 32.76373], [-96.846838, 32.763979], [-96.847424, 32.763979], [-96.848204, 32.763979], [-96.849749, 32.76378], [-96.851294, 32.76338], [-96.853255, 32.76278], [-96.855216, 32.76238], [-96.856582, 32.762081], [-96.856523, 32.76263], [-96.855572, 32.76273], [-96.854681, 32.76328], [-96.853493, 32.76358], [-96.852661, 32.764029], [-96.851769, 32.764279], [-96.850106, 32.764929], [-96.848382, 32.765328], [-96.848382, 32.768476], [-96.848501, 32.770924], [-96.847135, 32.770974], [-96.843807, 32.771124], [-96.840836, 32.771174], [-96.839054, 32.771074], [-96.838994, 32.768077], [-96.838043, 32.768526], [-96.837093, 32.769126], [-96.835964, 32.769775], [-96.835369, 32.770175], [-96.834775, 32.770625], [-96.834062, 32.771174], [-96.833527, 32.771674], [-96.832814, 32.772223], [-96.832161, 32.772373], [-96.831448, 32.772673], [-96.831032, 32.772873], [-96.831091, 32.771524]]]]
    },
    "properties": {
      "name": "Oak Cliff",
      "holc_id": "C1",
      "holc_grade": "C",
      "area_description_data": {
        "5": "Section south of Fort Worth Highway largely vacant. Part of area North of Highway contains residential development. Reason for increase in value since 1929 is fact that Fort Worth Highway was not opened until 1932 and prior to that time transportation facilities were inadequate and demand for propery in this section was almost nil.",
        "6": "Oak Cliff   Dallas, Texas C 1",
        "31": "70",
        "32": "15",
        "33": "15",
        "1a": "Rolling.",
        "1b": "Has all city conveniences, adequate transportation. School in area. ",
        "1c": "Fort Worth Highway through center of area along which is located tourist camps, small drink & lunch stands, illing stations. Unpaved streets.",
        "1d": "50",
        "1e": "Static",
        "2a": "Oil refinery workers, clerical",
        "2b": "1000-1800",
        "2c": "No -",
        "2d": "No ",
        "2e": "None",
        "2f": "Few",
        "2g": "Slightly  ",
        "3a": "Singles 4/6 rs. Singles 4/5 rs. Singles 5/10 rs.",
        "3b": "Frame Frame Frame",
        "3c": "15 20 30",
        "3d": "Good Fair Fair",
        "3e": "100 98 95",
        "3f": "70 70 60",
        "3g": "20 to 3500 None None",
        "3h": "1000-2250 500-1250 1300-1800",
        "3i": "1936 1750-3000 154 750-1500 135 1750-2250 130",
        "3j": "1938 1750-3000 154 750-1500 135 1750-2250 130",
        "3k": "to 2500 Fair to 1250 Fair to 2000 Poor",
        "3l": "Fair Fair Poor",
        "3m": "10-20 7.50-12.50 12-17",
        "3n": "1936 15-30 150 10-15 127 15-20 121",
        "3o": "1938 15-39 150 10-15 127 15-20 121",
        "3p": "to 25 - Good to 12.50 - Fair to 17.50 - Poor",
        "3q": "Fair Fair Poor",
        "4a": "Limited",
        "4b": "Limited"
      }
    }
  }, {
    "type": "Feature",
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [[[[-96.793612, 32.791748], [-96.794762, 32.790761], [-96.794782, 32.790775], [-96.79596, 32.791577], [-96.798127, 32.793303], [-96.80058, 32.795509], [-96.801949, 32.796516], [-96.803318, 32.797666], [-96.805315, 32.799345], [-96.8056, 32.800543], [-96.806171, 32.801694], [-96.804459, 32.802653], [-96.803718, 32.80342], [-96.80309, 32.804139], [-96.802805, 32.804763], [-96.802577, 32.805338], [-96.802178, 32.806201], [-96.801778, 32.80716], [-96.801436, 32.808023], [-96.800923, 32.808934], [-96.800523, 32.809605], [-96.800067, 32.810516], [-96.799839, 32.811139], [-96.799382, 32.811427], [-96.798965, 32.811643], [-96.798641, 32.811811], [-96.795561, 32.810612], [-96.795846, 32.809893], [-96.795218, 32.809461], [-96.794077, 32.808407], [-96.792822, 32.807256], [-96.791282, 32.806009], [-96.790084, 32.804763], [-96.788487, 32.803708], [-96.786662, 32.801982], [-96.784038, 32.799824], [-96.786034, 32.798146], [-96.786404, 32.797831], [-96.787525, 32.796875], [-96.789856, 32.794885], [-96.79191, 32.793207], [-96.793612, 32.791748]]]]
    },
    "properties": {
      "name": null,
      "holc_id": "C10",
      "holc_grade": "C",
      "area_description_data": {
        "5": "Better part of area is southeast corner & northeast corner. A general mixture of most every type of old property and also population. Thomas and State streets best negro streets.",
        "6": "Dallas, Texas C 10",
        "31": "60",
        "32": "20",
        "33": "20",
        "1a": "Level to rolling.",
        "1b": "Schools, churches, stores in area. Adequate transportation. All city conveniences. Near principal business district.",
        "1c": "Railroad tracks through area, cemetary in area. Mixtures of population and type of construction. Encroachment of commercial and industrial establishments, rooming houses.",
        "1d": "100",
        "1e": "Down",
        "2a": "Laborers, clerical, small merchants, etc.",
        "2b": "400-2000",
        "2c": "5 Italians",
        "2d": "Yes 15% ",
        "2e": "lower grade slowly",
        "2f": "Some",
        "2g": "  Yes",
        "3a": "Singles 4/7 rs. Singles 3/7 rs. 2 sty.& 4 fam. apts.",
        "3b": "Frame Frame Frame",
        "3c": "35 35 30",
        "3d": "Poor Poor Poor",
        "3e": "90 90 85",
        "3f": "15 15 10",
        "3g": "None None None",
        "3h": "1200-3500 1000-3000 3000-5500",
        "3i": "1936 1000-2750 81 750-2000 71 2500-4500 83",
        "3j": "1938 1000-2750 81 750-2000 71 2500-4500 83",
        "3k": "None None None",
        "3l": "None None None",
        "3m": "17.50-35 12.50-30 25-40",
        "3n": "1936 15-30 86 10-25 82 20-35 84",
        "3o": "1938 15-30 86 10-25 82 10-35 84",
        "3p": "to 25 - poor to 20 - poor to 25 - poor",
        "3q": "Poor Poor Poor",
        "4a": "Limited",
        "4b": "Limited"
      }
    }
  }, {
    "type": "Feature",
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [[[[-96.829558, 32.817468], [-96.828018, 32.816221], [-96.827448, 32.816269], [-96.826478, 32.816605], [-96.825565, 32.81694], [-96.824881, 32.816796], [-96.824139, 32.816173], [-96.823398, 32.81555], [-96.822656, 32.816269], [-96.821572, 32.817276], [-96.82026, 32.818426], [-96.820203, 32.818906], [-96.820203, 32.819433], [-96.823398, 32.821782], [-96.82471, 32.822022], [-96.825622, 32.822501], [-96.826022, 32.822741], [-96.827105, 32.823604], [-96.825223, 32.82509], [-96.824025, 32.826], [-96.822941, 32.827055], [-96.822143, 32.827678], [-96.821401, 32.828205], [-96.820774, 32.828397], [-96.820146, 32.828589], [-96.819861, 32.828876], [-96.819102, 32.828336], [-96.818236, 32.827719], [-96.817204, 32.826984], [-96.816495, 32.82648], [-96.816611, 32.825245], [-96.816811, 32.82311], [-96.816995, 32.821145], [-96.817066, 32.820392], [-96.817207, 32.817809], [-96.817294, 32.816221], [-96.817351, 32.814831], [-96.813757, 32.81229], [-96.813016, 32.812817], [-96.809821, 32.810181], [-96.810392, 32.809413], [-96.808852, 32.808311], [-96.808053, 32.80903], [-96.804231, 32.806201], [-96.804117, 32.805386], [-96.804459, 32.805146], [-96.805087, 32.804523], [-96.805771, 32.8039], [-96.80657, 32.803852], [-96.807197, 32.803228], [-96.807654, 32.802653], [-96.808167, 32.802126], [-96.809137, 32.801646], [-96.809935, 32.801359], [-96.810506, 32.801359], [-96.810905, 32.801071], [-96.813301, 32.802941], [-96.814955, 32.801454], [-96.815811, 32.801359], [-96.816324, 32.801598], [-96.816552, 32.801454], [-96.816324, 32.799441], [-96.817351, 32.800495], [-96.818435, 32.801598], [-96.819119, 32.802557], [-96.819918, 32.803564], [-96.820431, 32.8039], [-96.821344, 32.804092], [-96.822827, 32.804427], [-96.824025, 32.804475], [-96.824995, 32.804523], [-96.82585, 32.804763], [-96.826535, 32.80529], [-96.826592, 32.805818], [-96.826991, 32.806633], [-96.827391, 32.807256], [-96.82779, 32.808023], [-96.828132, 32.809126], [-96.828417, 32.810037], [-96.828189, 32.810756], [-96.828018, 32.812002], [-96.827676, 32.813393], [-96.830129, 32.813728], [-96.830813, 32.814591], [-96.831726, 32.815406], [-96.83241, 32.815933], [-96.833038, 32.816509], [-96.836517, 32.819433], [-96.838799, 32.821446], [-96.841994, 32.824131], [-96.843077, 32.825185], [-96.84496, 32.826623], [-96.846956, 32.828301], [-96.842849, 32.830985], [-96.841765, 32.830266], [-96.839598, 32.828637], [-96.838685, 32.828109], [-96.838115, 32.827678], [-96.837088, 32.826719], [-96.835205, 32.825137], [-96.834179, 32.824131], [-96.833722, 32.824083], [-96.833095, 32.823412], [-96.831726, 32.821878], [-96.831498, 32.821398], [-96.830528, 32.82044], [-96.831726, 32.819577], [-96.830699, 32.818474], [-96.829558, 32.817468]]]]
    },
    "properties": {
      "name": null,
      "holc_id": "C11",
      "holc_grade": "C",
      "area_description_data": {
        "5": "Part of area southeast of St. L. & S.W. R.R. and extreme northeast corner best part of area. Part along railroad traks west of Sylvester St. is worst part. On Maple Ave. at Lucas St. is located Cedar Spring Place, Government low-cost housing projest. It contains 181 units, has been open one year and all units are reported occupied. Several large, expensive old homes in southeast corner on Turtle Creek Blvd.",
        "6": "Dallas, Texas C 11",
        "31": "70",
        "32": "20",
        "33": "10",
        "1a": "Level to rolling.",
        "1b": "All city conveniences, schools, churches and stores in area. Adequate transportation.",
        "1c": "Railroad track, encroachment of small industrial plants, unpaved streets and general mixture of construction. City hospital in area.",
        "1d": "80",
        "1e": "Static",
        "2a": "Laborers, mechanics, clerical, small merchants, some professional men, etc.",
        "2b": "500-3000",
        "2c": "None -",
        "2d": "None ",
        "2e": "lower grade very/ slowly",
        "2f": "Few",
        "2g": "  Yes",
        "3a": "Singles 4/7 rs. Apts.4/16 units 3/5 rs. Singles 8/12 rs/",
        "3b": "Frame Frame & brick Frame & brick",
        "3c": "25 20 25",
        "3d": "Fair Good Fair",
        "3e": "95 90 90",
        "3f": "45 15 20",
        "3g": "30 to 3000 None None",
        "3h": "2000-6000 5000-20,000 3500-7500",
        "3i": "1936 1500-4500 75 4000-17,500 84 3000-6500 86",
        "3j": "1938 1500-4500 75 4000-17,500 84 3000-6500 86",
        "3k": "to 3000 - poor None None",
        "3l": "Poor None None",
        "3m": "20-55 20-50 40-75",
        "3n": "1936 17.50-47.50 87 17.50-45 89 35-60 84",
        "3o": "1938 17.50-47.50 87 17.50-45 89 35-60 84",
        "3p": "to 35 - fair to 35 - fair to 35 - fair",
        "3q": "Fair Fair Fair",
        "4a": "Ample",
        "4b": "Ample"
      }
    }
  }, {
    "type": "Feature",
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [[[[-96.845359, 32.833286], [-96.846671, 32.834628], [-96.847755, 32.835635], [-96.849238, 32.836881], [-96.850208, 32.837839], [-96.85152, 32.838654], [-96.85249, 32.839181], [-96.853003, 32.839229], [-96.854486, 32.839948], [-96.855969, 32.840523], [-96.85654, 32.840763], [-96.859962, 32.838271], [-96.861502, 32.83712], [-96.863328, 32.835443], [-96.865724, 32.837456], [-96.864697, 32.838175], [-96.863442, 32.839421], [-96.861616, 32.840811], [-96.859791, 32.842297], [-96.860875, 32.842824], [-96.862643, 32.843782], [-96.864355, 32.844645], [-96.865952, 32.845124], [-96.867663, 32.845651], [-96.866123, 32.846849], [-96.864526, 32.848335], [-96.862757, 32.849916], [-96.86213, 32.851306], [-96.861674, 32.852025], [-96.860989, 32.852456], [-96.859848, 32.853127], [-96.858878, 32.853798], [-96.858023, 32.855092], [-96.857338, 32.855811], [-96.856597, 32.856242], [-96.856368, 32.856577], [-96.855741, 32.857296], [-96.854828, 32.857919], [-96.853573, 32.856721], [-96.855684, 32.854708], [-96.858308, 32.852025], [-96.860076, 32.850491], [-96.86116, 32.849198], [-96.85808, 32.84637], [-96.85614, 32.844453], [-96.854144, 32.842824], [-96.849809, 32.846658], [-96.847584, 32.848575], [-96.845644, 32.850539], [-96.842336, 32.850779], [-96.839826, 32.850971], [-96.839598, 32.848143], [-96.83937, 32.845891], [-96.839313, 32.844597], [-96.841309, 32.84244], [-96.843876, 32.839948], [-96.845816, 32.838079], [-96.844504, 32.836929], [-96.843363, 32.835922], [-96.842906, 32.835059], [-96.845359, 32.833286]]]]
    },
    "properties": {
      "name": null,
      "holc_id": "C12",
      "holc_grade": "C",
      "area_description_data": {
        "5": "About 30 new houses built within past 12 months in Northern part of area between Love Field Drive and Bachman's Lake, along Wylie Drive, Noyes, Weiss and Reeves, and Shore Crest Drive. Also some new buildings of small houses West of Denton Drive. Southeast part of area contains many smaller houses occupied by factory workers. Airport is being extended toward southeast and it is anticipated that streets will be closed for two or three blocks in this direction, but not many houses to be razed and all only small cheapplaces.",
        "6": "Dallas, Texas C 12",
        "31": "85",
        "32": "10",
        "33": "5",
        "1a": "Level to rolling.",
        "1b": "Bus transportation adequate. Business center in area. Lake on northwest side. Has all public utilities.",
        "1c": "Some distance to school. Part south and southwest side and southeast side not in city limits. Several industrial plants along Denton Drive. Municipal arport in center of area. Unpaved streets.",
        "1d": "60",
        "1e": "Static",
        "2a": "Clerical, facory workers, mechanics, laborers",
        "2b": "800-3000",
        "2c": "None -",
        "2d": "None ",
        "2e": "None",
        "2f": "Few",
        "2g": "very slow  ",
        "3a": "Singles 3/6 rs. Singles 5/6 rs. Singles 4/5 rs.",
        "3b": "Frame Frame & brick Frame",
        "3c": "17 2 2",
        "3d": "Fair to poor Good Good",
        "3e": "90 98 95",
        "3f": "40 80 75",
        "3g": "None 30-5000 40-2750",
        "3h": "1500-3250 - -",
        "3i": "1936 1000-2500 72 - - - -",
        "3j": "1938 1000-2500 72 3500-5500 - 2000-2750 -",
        "3k": "Poor to 5000 - Fair to 2500 - Fair",
        "3l": "Poor Fair Fair",
        "3m": "15-35 - -",
        "3n": "1936 12.50-25 77 - - - ",
        "3o": "1938 12.50-25 77 35-50 - 20-30 -",
        "3p": "to 20 - fair to 40 - fair to 25 - fair",
        "3q": "Fair Fair Fair",
        "4a": "Ample",
        "4b": "Ample"
      }
    }
  }, {
    "type": "Feature",
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [[[[-96.84849, 32.755569], [-96.848966, 32.755319], [-96.848927, 32.754679], [-96.848847, 32.75337], [-96.848884, 32.752982], [-96.848995, 32.751836], [-96.849025, 32.751521], [-96.849108, 32.750781], [-96.849203, 32.749922], [-96.848669, 32.748872], [-96.848691, 32.748068], [-96.848707, 32.747519], [-96.848728, 32.746773], [-96.847668, 32.746385], [-96.846411, 32.745924], [-96.845412, 32.745504], [-96.844271, 32.745024], [-96.843249, 32.744594], [-96.842608, 32.744325], [-96.842964, 32.740976], [-96.843261, 32.739027], [-96.84344, 32.736878], [-96.843915, 32.734728], [-96.843974, 32.732929], [-96.844153, 32.731529], [-96.844212, 32.73028], [-96.844212, 32.72923], [-96.844212, 32.72823], [-96.844248, 32.727603], [-96.844271, 32.727181], [-96.844186, 32.726751], [-96.844093, 32.726281], [-96.84297, 32.726266], [-96.842079, 32.726255], [-96.841128, 32.726242], [-96.840231, 32.726231], [-96.840231, 32.724981], [-96.838508, 32.725031], [-96.83625, 32.724981], [-96.83625, 32.723931], [-96.836428, 32.721882], [-96.836428, 32.720332], [-96.839934, 32.720332], [-96.839934, 32.721232], [-96.842429, 32.721182], [-96.845341, 32.721182], [-96.845341, 32.719482], [-96.845341, 32.718282], [-96.845341, 32.716783], [-96.845341, 32.715633], [-96.845282, 32.714083], [-96.847005, 32.714083], [-96.849025, 32.714183], [-96.849084, 32.715683], [-96.849084, 32.718082], [-96.848966, 32.720132], [-96.851105, 32.720132], [-96.853838, 32.720082], [-96.857047, 32.720182], [-96.857047, 32.721582], [-96.857106, 32.723881], [-96.856809, 32.725531], [-96.856571, 32.72768], [-96.854254, 32.72773], [-96.853719, 32.72783], [-96.853719, 32.72888], [-96.85366, 32.73013], [-96.8536, 32.731879], [-96.853482, 32.734278], [-96.854254, 32.734278], [-96.855145, 32.734378], [-96.856096, 32.734428], [-96.857344, 32.734378], [-96.859245, 32.734328], [-96.860671, 32.734428], [-96.861681, 32.734428], [-96.863226, 32.734428], [-96.864296, 32.734428], [-96.865425, 32.734278], [-96.866613, 32.734278], [-96.867683, 32.734228], [-96.86905, 32.733929], [-96.869584, 32.734378], [-96.873981, 32.733879], [-96.873922, 32.732679], [-96.874041, 32.731129], [-96.874041, 32.72993], [-96.873981, 32.72863], [-96.873803, 32.725981], [-96.876418, 32.726031], [-96.878557, 32.726081], [-96.882063, 32.726081], [-96.8823, 32.72993], [-96.882835, 32.73013], [-96.88539, 32.73078], [-96.889847, 32.731629], [-96.89258, 32.734128], [-96.89252, 32.738227], [-96.892461, 32.741126], [-96.892223, 32.745974], [-96.891154, 32.745874], [-96.888064, 32.746024], [-96.888361, 32.742575], [-96.880696, 32.742475], [-96.880221, 32.743175], [-96.879864, 32.744225], [-96.879567, 32.745574], [-96.879507, 32.747023], [-96.879329, 32.749072], [-96.879329, 32.750621], [-96.875051, 32.750372], [-96.874992, 32.754719], [-96.870773, 32.757068], [-96.864831, 32.757018], [-96.86489, 32.75427], [-96.8659, 32.75427], [-96.86596, 32.750022], [-96.862395, 32.749772], [-96.862395, 32.750671], [-96.858413, 32.75312], [-96.85877, 32.749572], [-96.85877, 32.747573], [-96.859661, 32.747573], [-96.861919, 32.747023], [-96.863108, 32.746673], [-96.864593, 32.746224], [-96.865544, 32.745824], [-96.866792, 32.745124], [-96.868039, 32.744574], [-96.86798, 32.743425], [-96.867921, 32.742175], [-96.866019, 32.742075], [-96.863939, 32.742026], [-96.860493, 32.741976], [-96.85669, 32.741826], [-96.856809, 32.743525], [-96.856453, 32.744774], [-96.856393, 32.746773], [-96.855621, 32.749472], [-96.85366, 32.750022], [-96.85366, 32.75277], [-96.854016, 32.755169], [-96.852115, 32.755219], [-96.85057, 32.756068], [-96.850392, 32.756718], [-96.848669, 32.756518], [-96.84849, 32.755569]]]]
    },
    "properties": {
      "name": "Oak Cliff",
      "holc_id": "C2",
      "holc_grade": "C",
      "area_description_data": {
        "5": "Section east of Oak Cliff Blvd. & North of Burlington best part of area. Much new construction south of Jefferson & west of Westmoreland, also north of Jefferson between Calumet & Francis also in part of area South of G. C & S.F. Railroad, also in Western part north of Davis Street. South of Davis & north of Jefferson between Kramer & Ravinnia not so good.",
        "6": "Oak Cliff Dallas, Texas C 2",
        "31": "80",
        "32": "15",
        "33": "5",
        "1a": "Level to gently rolling.",
        "1b": "All city conveniences, good schools, adequate transportation. Business center in area. Close to Stevens Park and El Tivoli Golf Courses.",
        "1c": "Many unpaved street, distance from principal business center of Dallas, mixture of low price poor construction.",
        "1d": "80",
        "1e": "Static.",
        "2a": "Clerical, Professional skilled and unskilled laborers,executives",
        "2b": "1000-3000",
        "2c": "None -",
        "2d": "None ",
        "2e": "None",
        "2f": "Few",
        "2g": "Slightly  ",
        "3a": "Singles 4/8 rs. Singles 5/7 rs. Apts.4/12 3/5 rooms",
        "3b": "Frame Brick Veneer Frame & brick",
        "3c": "20 12 15",
        "3d": "Fair - Good Good Fair - Good",
        "3e": "98 98 85",
        "3f": "65 80 20",
        "3g": "200-4500 30 to 5000 None",
        "3h": "1500-5000 400-6000 6500-17,500",
        "3i": "1936 1250-4500 87 3500-5750 92 5000-15,000 81",
        "3j": "1938 1250-4500 87 3500-5750 92 5000-15,000 81",
        "3k": "to 35000 - fair to 4750 - fair None",
        "3l": "Fair Fair None",
        "3m": "20-55 40-55 32.50-55",
        "3n": "1936 15-45 78 35-50 89 25-45 79",
        "3o": "1938 15-45 78 35-50 89 25-45 79",
        "3p": "to 40 - good to 40 - good to 40 - fair",
        "3q": "Good Good Fair",
        "4a": "Ample",
        "4b": "Ample"
      }
    }
  }, {
    "type": "Feature",
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [[[[-96.812304, 32.759416], [-96.811709, 32.758567], [-96.811056, 32.757268], [-96.810699, 32.756068], [-96.810521, 32.755369], [-96.81064, 32.754619], [-96.810699, 32.75377], [-96.810937, 32.752371], [-96.81165, 32.751521], [-96.813492, 32.748972], [-96.814086, 32.748223], [-96.814859, 32.748073], [-96.815809, 32.747523], [-96.817414, 32.746773], [-96.818959, 32.745924], [-96.820801, 32.744924], [-96.822643, 32.744075], [-96.824603, 32.743575], [-96.826861, 32.743475], [-96.831912, 32.743575], [-96.83625, 32.743675], [-96.839161, 32.743875], [-96.839102, 32.742325], [-96.835537, 32.742475], [-96.833516, 32.742425], [-96.831556, 32.742475], [-96.830011, 32.742475], [-96.827337, 32.742425], [-96.825257, 32.742425], [-96.824247, 32.742475], [-96.823831, 32.742575], [-96.823059, 32.742825], [-96.822227, 32.742975], [-96.821395, 32.743275], [-96.820206, 32.743725], [-96.819077, 32.744325], [-96.818424, 32.744674], [-96.81676, 32.745724], [-96.815809, 32.746124], [-96.815096, 32.746573], [-96.814621, 32.746973], [-96.813908, 32.747223], [-96.813076, 32.748023], [-96.812957, 32.746424], [-96.813017, 32.743075], [-96.813545, 32.742976], [-96.813828, 32.742923], [-96.814621, 32.742775], [-96.81527, 32.7428], [-96.815928, 32.742825], [-96.816819, 32.742825], [-96.817176, 32.742825], [-96.817651, 32.742775], [-96.818543, 32.742425], [-96.818543, 32.741876], [-96.818516, 32.741275], [-96.818483, 32.740526], [-96.818029, 32.739923], [-96.817773, 32.739583], [-96.817354, 32.739027], [-96.816658, 32.739634], [-96.816048, 32.740166], [-96.815334, 32.740676], [-96.814621, 32.740826], [-96.814205, 32.741176], [-96.813551, 32.741276], [-96.812763, 32.741682], [-96.81266, 32.740876], [-96.813204, 32.740379], [-96.814062, 32.739596], [-96.815025, 32.738718], [-96.815453, 32.738327], [-96.815962, 32.73796], [-96.816696, 32.737431], [-96.817532, 32.736828], [-96.818155, 32.736349], [-96.818899, 32.735778], [-96.819669, 32.735211], [-96.820325, 32.734728], [-96.820873, 32.734286], [-96.821357, 32.733895], [-96.821811, 32.733529], [-96.822643, 32.733229], [-96.824425, 32.733279], [-96.826148, 32.733329], [-96.828466, 32.733079], [-96.83013, 32.733629], [-96.832209, 32.734079], [-96.834111, 32.734128], [-96.834943, 32.733929], [-96.837498, 32.733279], [-96.840231, 32.732779], [-96.841479, 32.732379], [-96.842548, 32.732079], [-96.843235, 32.731844], [-96.844153, 32.731529], [-96.843974, 32.732929], [-96.843915, 32.734728], [-96.84344, 32.736878], [-96.843261, 32.739027], [-96.842964, 32.740976], [-96.842608, 32.744325], [-96.841776, 32.744025], [-96.841776, 32.745824], [-96.841776, 32.747173], [-96.841776, 32.749222], [-96.841835, 32.750771], [-96.842845, 32.751721], [-96.841419, 32.75312], [-96.841419, 32.75372], [-96.838924, 32.75382], [-96.837735, 32.75392], [-96.837735, 32.752071], [-96.835828, 32.752095], [-96.833814, 32.752121], [-96.833576, 32.75262], [-96.832982, 32.75287], [-96.831853, 32.75252], [-96.830189, 32.752471], [-96.828585, 32.752321], [-96.828466, 32.754319], [-96.828406, 32.755419], [-96.828287, 32.756418], [-96.827574, 32.757518], [-96.827099, 32.758417], [-96.826743, 32.759217], [-96.827218, 32.759217], [-96.827116, 32.759695], [-96.826985, 32.760316], [-96.826921, 32.760616], [-96.826762, 32.76125], [-96.826683, 32.761565], [-96.826486, 32.761897], [-96.826089, 32.762565], [-96.825936, 32.762658], [-96.825435, 32.762964], [-96.824663, 32.763364], [-96.824827, 32.763561], [-96.825264, 32.764086], [-96.825791, 32.76455], [-96.826208, 32.764813], [-96.822999, 32.764813], [-96.82307, 32.766578], [-96.821932, 32.766559], [-96.82086, 32.766542], [-96.81998, 32.766528], [-96.819137, 32.765612], [-96.818364, 32.765013], [-96.817414, 32.764113], [-96.816582, 32.763364], [-96.815156, 32.762664], [-96.813848, 32.762115], [-96.812541, 32.761515], [-96.812482, 32.760016], [-96.812304, 32.759416]], [[-96.821573, 32.756368], [-96.821514, 32.754919], [-96.816938, 32.754969], [-96.817057, 32.758617], [-96.81783, 32.758617], [-96.818602, 32.758517], [-96.819672, 32.758517], [-96.81985, 32.758217], [-96.820503, 32.757867], [-96.821038, 32.757618], [-96.821454, 32.757168], [-96.821573, 32.756368]], [[-96.839042, 32.749822], [-96.837557, 32.748922], [-96.835002, 32.748922], [-96.832982, 32.748922], [-96.830961, 32.748772], [-96.828406, 32.748722], [-96.826683, 32.748722], [-96.826802, 32.749722], [-96.826921, 32.749922], [-96.827693, 32.749922], [-96.829535, 32.749922], [-96.830961, 32.749972], [-96.83316, 32.749972], [-96.835061, 32.749972], [-96.837557, 32.750022], [-96.838508, 32.750721], [-96.838448, 32.750222], [-96.839042, 32.749822]]]]
    },
    "properties": {
      "name": "Oak Cliff",
      "holc_id": "C3",
      "holc_grade": "C",
      "area_description_data": {
        "5": "Jefferson Ave. is largely business all through area and around its intersection with Beckley and Marsalis is several blocks are included in business. Marsalis, beckley, and Bishop North of Jefferson predominate in apartments. Also many apartments in Kings Highway. Clinton,Winnetka,Willoment,Elsbeth,Zang Blvd., are better streets.The area is composed of almost every type of of property, good, bad and indifferent, single family, 2 story and apartments,cheap old houses, and more modern good houses, with predomination in older properties. As a whole the part of area North of Jefferson is better than the part South of Jefferson.",
        "6": "Oak Cliff Dallas, Texas C 3",
        "31": "70",
        "32": "15",
        "33": "15",
        "1a": "Level to gently rolling.",
        "1b": "All city conveniences, grade schools & high school, churches and business center in area. Adequate transportation. Parks in area.",
        "1c": "Mixed type of construction, older properties transition to business center in area. Nothing but zoning restrictions in area, City Zoo in southeast corner.",
        "1d": "95",
        "1e": "Static",
        "2a": "Executives, business men, professional men, clerical, skilled and unskilled laborers",
        "2b": "1000-2500",
        "2c": "None ",
        "2d": "No ",
        "2e": "None",
        "2f": "Few",
        "2g": "  Yes",
        "3a": "Singles 5/7 rs. 2 story singles 6/8 rs. Apts.4/16 units 3/5 rs. This area also contains 2 hotel apts. in addition.",
        "3b": "Frame & brick veneer Frame & brick veneer Frame & brick",
        "3c": "25 25 20",
        "3d": "Fair - good Fair Fair",
        "3e": "95 95 90",
        "3f": "45 65 15",
        "3g": "50-3500 None None",
        "3h": "2000-4500 4250-6500 5000-25,000",
        "3i": "1936 1600-3500 79 3500-5500 83 4000-20,000 80",
        "3j": "1938 1600-3500 79 3500-5500 83 4000-20,000 80",
        "3k": "None None None",
        "3l": "Fair Fair Fair",
        "3m": "20-50 35-55 30-65",
        "3n": "1936 15-40 88 30-45 84 20-50 72",
        "3o": "1938 15-40 88 30-45 84 20-50 72",
        "3p": "to 40 - fair to 40 - fair Fair",
        "3q": "Fair Fair Fair",
        "4a": "Ample",
        "4b": "Ample"
      }
    }
  }, {
    "type": "Feature",
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [[[[-96.79008, 32.726981], [-96.791031, 32.72788], [-96.791507, 32.72878], [-96.79222, 32.72943], [-96.792695, 32.731179], [-96.793051, 32.731279], [-96.793705, 32.731029], [-96.79418, 32.73073], [-96.795309, 32.73043], [-96.79632, 32.73003], [-96.79733, 32.72953], [-96.798162, 32.72908], [-96.799231, 32.72858], [-96.800954, 32.72773], [-96.80042, 32.726131], [-96.799885, 32.725181], [-96.798696, 32.723281], [-96.799885, 32.722732], [-96.80036, 32.722132], [-96.800479, 32.721482], [-96.799231, 32.720882], [-96.794121, 32.718982], [-96.795369, 32.718682], [-96.796379, 32.718232], [-96.797805, 32.717682], [-96.798399, 32.717183], [-96.799825, 32.716833], [-96.80137, 32.716833], [-96.803866, 32.716833], [-96.804995, 32.716633], [-96.806183, 32.716583], [-96.807253, 32.716583], [-96.808144, 32.716583], [-96.809451, 32.716583], [-96.80957, 32.716583], [-96.810759, 32.716583], [-96.812006, 32.716583], [-96.813433, 32.716683], [-96.813373, 32.718682], [-96.813314, 32.721132], [-96.813195, 32.722382], [-96.813076, 32.724331], [-96.813135, 32.726431], [-96.813314, 32.72873], [-96.813314, 32.73003], [-96.814859, 32.73008], [-96.817532, 32.73003], [-96.819553, 32.73003], [-96.819669, 32.735211], [-96.818899, 32.735778], [-96.818155, 32.736349], [-96.817532, 32.736828], [-96.816696, 32.737431], [-96.815962, 32.73796], [-96.815453, 32.738327], [-96.815025, 32.738718], [-96.814062, 32.739596], [-96.813204, 32.740379], [-96.81266, 32.740876], [-96.812763, 32.741682], [-96.811709, 32.741426], [-96.810759, 32.741126], [-96.809808, 32.741026], [-96.808857, 32.740976], [-96.808857, 32.740176], [-96.808738, 32.738527], [-96.806659, 32.738477], [-96.80446, 32.738477], [-96.802737, 32.738377], [-96.802262, 32.739726], [-96.801905, 32.740676], [-96.80137, 32.741726], [-96.800717, 32.742425], [-96.800182, 32.742875], [-96.799409, 32.743175], [-96.798875, 32.743775], [-96.797983, 32.744225], [-96.79727, 32.744674], [-96.796438, 32.745024], [-96.795785, 32.745174], [-96.795607, 32.746524], [-96.795904, 32.747923], [-96.794299, 32.747573], [-96.792754, 32.747523], [-96.79115, 32.747223], [-96.789486, 32.747223], [-96.787644, 32.747123], [-96.786515, 32.747023], [-96.786575, 32.746224], [-96.786753, 32.745274], [-96.786991, 32.744275], [-96.787228, 32.743475], [-96.787763, 32.742425], [-96.788238, 32.741476], [-96.788476, 32.740726], [-96.788833, 32.739776], [-96.788833, 32.739277], [-96.789308, 32.738477], [-96.789546, 32.737977], [-96.789546, 32.736728], [-96.789486, 32.736128], [-96.788951, 32.735078], [-96.788417, 32.734328], [-96.787763, 32.733629], [-96.787228, 32.732729], [-96.786575, 32.731429], [-96.786218, 32.73028], [-96.785505, 32.72898], [-96.786753, 32.72853], [-96.788714, 32.72773], [-96.79008, 32.726981]], [[-96.81064, 32.726181], [-96.81058, 32.72873], [-96.810521, 32.72978], [-96.812006, 32.72968], [-96.811888, 32.726131], [-96.81064, 32.726181]]]]
    },
    "properties": {
      "name": "Oak Cliff",
      "holc_id": "C4",
      "holc_grade": "C",
      "area_description_data": {
        "5": "New construction scattered all over area, southeast, central portion and eastern edge has most activity in new building. An area without any outstanding favorable or detrimental influences - but cheaply priced.",
        "6": "Oak Cliff Dallas, Texas C 4",
        "31": "100",
        "32": "",
        "33": "",
        "1a": "Level to gently rolling.",
        "1b": "All city conveniences, schools and churches in area. Adequate transportation.",
        "1c": "M   d type of construction - railroad - many unpaved streets",
        "1d": "70",
        "1e": "Static",
        "2a": "Clerical, laborers, skilled and unskilled some business m",
        "2b": "1000-2500",
        "2c": "None -",
        "2d": "None ",
        "2e": "None",
        "2f": "Few",
        "2g": "Slowly  ",
        "3a": "Singles 4/6 rs.  ",
        "3b": "Frame  ",
        "3c": "17  ",
        "3d": "Fair to good  ",
        "3e": "98  ",
        "3f": "75  ",
        "3g": "200 to $3000  ",
        "3h": "1500-3250  ",
        "3i": "1936 1250-2500 80    ",
        "3j": "1938 1250-2500 80    ",
        "3k": "to 2250 Fair  ",
        "3l": "Fair  ",
        "3m": "20-35  ",
        "3n": "1936 15-27.50 77    ",
        "3o": "1938 15-27.50 77    ",
        "3p": "to 25 - Fair  ",
        "3q": "Fair  ",
        "4a": "Ample",
        "4b": "Ample"
      }
    }
  }, {
    "type": "Feature",
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [[[[-96.813433, 32.716683], [-96.812006, 32.716583], [-96.810759, 32.716583], [-96.80957, 32.716583], [-96.809451, 32.716583], [-96.808144, 32.716583], [-96.807253, 32.716583], [-96.806183, 32.716583], [-96.804995, 32.716633], [-96.803866, 32.716833], [-96.804282, 32.713283], [-96.804104, 32.712033], [-96.80036, 32.706183], [-96.79323, 32.709733], [-96.791566, 32.707783], [-96.792101, 32.705133], [-96.790259, 32.702383], [-96.793883, 32.700683], [-96.791685, 32.697383], [-96.791447, 32.696683], [-96.793527, 32.696283], [-96.79222, 32.692933], [-96.791328, 32.691182], [-96.790437, 32.689382], [-96.789367, 32.686732], [-96.788714, 32.685631], [-96.787347, 32.683631], [-96.786515, 32.682081], [-96.785565, 32.68063], [-96.787882, 32.67998], [-96.791863, 32.67888], [-96.79317, 32.68038], [-96.793586, 32.68138], [-96.794299, 32.68133], [-96.794953, 32.682581], [-96.795963, 32.684381], [-96.80042, 32.683331], [-96.801489, 32.684781], [-96.801964, 32.685681], [-96.80345, 32.687682], [-96.805292, 32.686632], [-96.805292, 32.689882], [-96.805292, 32.690732], [-96.805708, 32.691382], [-96.810343, 32.690882], [-96.810224, 32.691733], [-96.810521, 32.692233], [-96.808501, 32.692333], [-96.808976, 32.694483], [-96.809451, 32.696633], [-96.809927, 32.698333], [-96.813551, 32.698333], [-96.817948, 32.698333], [-96.817948, 32.701933], [-96.817948, 32.703283], [-96.818067, 32.707283], [-96.823296, 32.707283], [-96.824188, 32.707483], [-96.824247, 32.709233], [-96.823296, 32.709283], [-96.823296, 32.711983], [-96.823237, 32.713983], [-96.823296, 32.715083], [-96.823237, 32.716433], [-96.825792, 32.716383], [-96.828822, 32.716433], [-96.831258, 32.716433], [-96.831258, 32.717482], [-96.831318, 32.718882], [-96.83114, 32.720332], [-96.828822, 32.720332], [-96.825435, 32.720282], [-96.823296, 32.720182], [-96.82086, 32.720132], [-96.817414, 32.720132], [-96.816047, 32.718782], [-96.814086, 32.716583], [-96.813433, 32.716683]]]]
    },
    "properties": {
      "name": "Oak Cliff",
      "holc_id": "C5",
      "holc_grade": "C",
      "area_description_data": {
        "5": "New construction in northeast and scattered all over area. Recent construction of two new schools has added stability of this area.",
        "6": "Oak Cliff Dallas, Texas C 5",
        "31": "100",
        "32": "",
        "33": "",
        "1a": "Level to rolling.",
        "1b": "Schools, churches, stores in area. Bus transportation.",
        "1c": "Mixed type of construction - Unpaved streets - distance to principal business center of Oak Cliff and Dallas.",
        "1d": "50",
        "1e": "Static",
        "2a": "Clerical, skilled and unskilled laborers. Some busines men.",
        "2b": "1000-2500",
        "2c": "None ",
        "2d": "None ",
        "2e": "None",
        "2f": "Few",
        "2g": "Slowly  ",
        "3a": "Singles 4/6 rs.  ",
        "3b": "Frame 5% brick  ",
        "3c": "15  ",
        "3d": "Good  ",
        "3e": "95  ",
        "3f": "80  ",
        "3g": "200 to 3500  ",
        "3h": "1200-3500  ",
        "3i": "1936 900-3250 84    ",
        "3j": "1938 900-3250 84    ",
        "3k": "to 3000 - fair  ",
        "3l": "Fair  ",
        "3m": "15-35  ",
        "3n": "1936 10-30 77    ",
        "3o": "1938 10-30 77    ",
        "3p": "to 25 - fair  ",
        "3q": "Fair  ",
        "4a": "Ample",
        "4b": "Ample"
      }
    }
  }, {
    "type": "Feature",
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [[[[-96.759832, 32.774628], [-96.759291, 32.774172], [-96.758934, 32.774561], [-96.758601, 32.774925], [-96.75815, 32.775419], [-96.75738, 32.776066], [-96.756952, 32.776426], [-96.756432, 32.777009], [-96.755925, 32.777577], [-96.755303, 32.778029], [-96.754816, 32.778383], [-96.754395, 32.77869], [-96.753814, 32.779112], [-96.751989, 32.777913], [-96.750677, 32.776762], [-96.74965, 32.775899], [-96.747939, 32.774891], [-96.749365, 32.773884], [-96.750563, 32.772829], [-96.751875, 32.771678], [-96.753244, 32.770335], [-96.754043, 32.769759], [-96.754955, 32.769136], [-96.755925, 32.768608], [-96.756895, 32.767985], [-96.756153, 32.767553], [-96.754556, 32.767073], [-96.753016, 32.766833], [-96.751932, 32.766785], [-96.750848, 32.766833], [-96.74965, 32.766881], [-96.748624, 32.766737], [-96.747768, 32.766594], [-96.74657, 32.766402], [-96.745429, 32.766498], [-96.744231, 32.766402], [-96.742862, 32.766402], [-96.741949, 32.766402], [-96.74058, 32.766306], [-96.73944, 32.766258], [-96.738013, 32.766258], [-96.738185, 32.765107], [-96.738413, 32.764147], [-96.738698, 32.763188], [-96.73904, 32.76242], [-96.739325, 32.761461], [-96.739782, 32.76031], [-96.740523, 32.758871], [-96.741379, 32.757336], [-96.742691, 32.755896], [-96.743832, 32.754409], [-96.745087, 32.75321], [-96.746285, 32.754121], [-96.747654, 32.755225], [-96.749251, 32.756616], [-96.75005, 32.757096], [-96.750791, 32.75652], [-96.751704, 32.755896], [-96.752674, 32.754937], [-96.753472, 32.754169], [-96.753871, 32.753738], [-96.754556, 32.75321], [-96.755241, 32.752586], [-96.756039, 32.752154], [-96.757351, 32.751243], [-96.757922, 32.750523], [-96.758834, 32.749948], [-96.759747, 32.74918], [-96.76026, 32.7487], [-96.759861, 32.747837], [-96.759462, 32.747165], [-96.758777, 32.746349], [-96.758321, 32.745342], [-96.758036, 32.74443], [-96.757922, 32.743519], [-96.758321, 32.742943], [-96.759005, 32.742511], [-96.759576, 32.742607], [-96.759975, 32.743423], [-96.760431, 32.744046], [-96.760774, 32.744622], [-96.761287, 32.74515], [-96.761458, 32.745438], [-96.762143, 32.74587], [-96.763112, 32.746493], [-96.763569, 32.746877], [-96.764196, 32.747501], [-96.765166, 32.74822], [-96.766193, 32.748988], [-96.766991, 32.749612], [-96.767391, 32.749996], [-96.768132, 32.750523], [-96.76876, 32.751579], [-96.769444, 32.75249], [-96.77045, 32.751941], [-96.7714, 32.75309], [-96.773064, 32.754389], [-96.774966, 32.755838], [-96.77657, 32.757138], [-96.777758, 32.758137], [-96.779125, 32.759286], [-96.778685, 32.759782], [-96.778286, 32.760166], [-96.777373, 32.760694], [-96.776746, 32.761173], [-96.776061, 32.761749], [-96.775491, 32.762324], [-96.77492, 32.762756], [-96.774464, 32.76314], [-96.77378, 32.763668], [-96.774806, 32.764771], [-96.775776, 32.763907], [-96.776746, 32.763092], [-96.777944, 32.762085], [-96.779142, 32.761269], [-96.780373, 32.760286], [-96.782155, 32.761685], [-96.783225, 32.762834], [-96.784116, 32.763534], [-96.78275, 32.764683], [-96.783403, 32.765532], [-96.782512, 32.766931], [-96.781383, 32.76858], [-96.780195, 32.769879], [-96.779303, 32.771178], [-96.778293, 32.772877], [-96.777342, 32.773477], [-96.776867, 32.774126], [-96.775916, 32.774726], [-96.774847, 32.775925], [-96.772826, 32.777673], [-96.771341, 32.779022], [-96.770984, 32.780121], [-96.770271, 32.782019], [-96.770034, 32.783218], [-96.769855, 32.784168], [-96.769663, 32.785151], [-96.769663, 32.784815], [-96.769663, 32.784767], [-96.768901, 32.784562], [-96.767577, 32.784205], [-96.766819, 32.784001], [-96.765214, 32.783568], [-96.765258, 32.783244], [-96.765377, 32.78237], [-96.765565, 32.781942], [-96.765765, 32.781424], [-96.765977, 32.780876], [-96.766307, 32.780023], [-96.765052, 32.779112], [-96.764253, 32.778441], [-96.763797, 32.778057], [-96.762208, 32.776693], [-96.762208, 32.776693], [-96.761723, 32.776264], [-96.761072, 32.775689], [-96.76066, 32.775323], [-96.759832, 32.774628]], [[-96.77532, 32.767745], [-96.773209, 32.766114], [-96.772353, 32.766737], [-96.771555, 32.767361], [-96.770357, 32.76856], [-96.769273, 32.769424], [-96.768417, 32.769903], [-96.767961, 32.770479], [-96.767391, 32.771054], [-96.766592, 32.77163], [-96.766022, 32.77211], [-96.766649, 32.772637], [-96.767334, 32.772973], [-96.768189, 32.773788], [-96.769159, 32.772925], [-96.769844, 32.772493], [-96.770699, 32.771582], [-96.771954, 32.770431], [-96.773608, 32.769232], [-96.77532, 32.767745]]]]
    },
    "properties": {
      "name": null,
      "holc_id": "C6",
      "holc_grade": "C",
      "area_description_data": {
        "5": "An area of old houses, not well kept, mixed population, unpaved streets, with practically no outstanding features in its favor.",
        "6": "Dallas, Texas C 6",
        "31": "70",
        "32": "20",
        "33": "10",
        "1a": "Level.",
        "1b": "All city conveniences, schools, churches, stores in area. Adequate transportation.",
        "1c": "Mixed type of construction and population. Unpaved streets. Cemetary in southeastern part of area.",
        "1d": "90",
        "1e": "Down",
        "2a": "Clerical, laborers, skilled and unskilled, some small business men.",
        "2b": "500-3000",
        "2c": "5 Italian,Russians-Greeks",
        "2d": "Yes 10% ",
        "2e": "lower grade slowly",
        "2f": "Few",
        "2g": "  Yes",
        "3a": "Singles 4/7 rs. Singles 8/12 rs. Apts. 4/16 units-3/6 rs. Duplexes",
        "3b": "Frame Frame Frame & brick",
        "3c": "25 30 17",
        "3d": "Fair - poor Poor Fair",
        "3e": "90 85 85",
        "3f": "50 40 35",
        "3g": "60 to 2500 None None",
        "3h": "2000-5000 3000-7000 3500-25,000",
        "3i": "1936 1500-3000 68 2000-5000 69 3000-17,500 78",
        "3j": "1938 1500-3000 68 2000-5000 69 3000-17,500 78",
        "3k": "None None None",
        "3l": "None None None",
        "3m": "15-40 27.50-65 15-45",
        "3n": "1936 12.50-35 87 20-50 75 12.50-35 81",
        "3o": "1938 15-27.50 87 20-50 75 12.50-35 81",
        "3p": "to 25 - Poor to 25 - Poor to 25 - Poor",
        "3q": "Poor Poor Poor",
        "4a": "Limited",
        "4b": "Limited"
      }
    }
  }, {
    "type": "Feature",
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [[[[-96.77532, 32.767745], [-96.773608, 32.769232], [-96.771954, 32.770431], [-96.770699, 32.771582], [-96.769844, 32.772493], [-96.769159, 32.772925], [-96.768189, 32.773788], [-96.767334, 32.772973], [-96.766649, 32.772637], [-96.766022, 32.77211], [-96.766592, 32.77163], [-96.767391, 32.771054], [-96.767961, 32.770479], [-96.768417, 32.769903], [-96.769273, 32.769424], [-96.770357, 32.76856], [-96.771555, 32.767361], [-96.772353, 32.766737], [-96.773209, 32.766114], [-96.77532, 32.767745]]]]
    },
    "properties": {
      "name": null,
      "holc_id": "C7",
      "holc_grade": "C",
      "area_description_data": {
        "5": "This area contains a much better type of property than surrounding area, practically all brick and well maintained. Population is largely composed of middle class Jews, and is inclining towards a lower-grade. Ordinarily this would be classed as a 2nd grade area, but due to location, surroundings and tendency to infiltration of lower grade population is is brought down to a high \"C\".",
        "6": "Oak Cliff Dallas, Texas C 7",
        "31": "100",
        "32": "",
        "33": "",
        "1a": "Level.",
        "1b": "Schools, stores in area. All city conveniences. Adequate transportation. Uniform type of construction.",
        "1c": "Type of population. Surrounding area.",
        "1d": "100",
        "1e": "Static",
        "2a": "Merchants,professional men - executives - clerical",
        "2b": "3000-10,000",
        "2c": "10 German Jews",
        "2d": "No ",
        "2e": "lower grade slowly",
        "2f": "None",
        "2g": "  Yes",
        "3a": "Singles 5/12 rs.  ",
        "3b": "Brick predominating  ",
        "3c": "20  ",
        "3d": "Good  ",
        "3e": "98  ",
        "3f": "75  ",
        "3g": "None  ",
        "3h": "6000-15,000  ",
        "3i": "1936 4000-10,000 67    ",
        "3j": "1938 4000-10,000 67    ",
        "3k": "None  ",
        "3l": "None  ",
        "3m": "50-125  ",
        "3n": "1936 40-85 74    ",
        "3o": "1938 40-85 74    ",
        "3p": "to 60 - fair  ",
        "3q": "Fair  ",
        "4a": "Limited",
        "4b": "Limited"
      }
    }
  }, {
    "type": "Feature",
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [[[[-96.747815, 32.805578], [-96.746789, 32.804811], [-96.746332, 32.804955], [-96.744279, 32.803133], [-96.74348, 32.802557], [-96.74251, 32.801598], [-96.741141, 32.801359], [-96.74, 32.800735], [-96.739715, 32.800304], [-96.740913, 32.799105], [-96.74194, 32.798146], [-96.74291, 32.797379], [-96.744507, 32.795701], [-96.745534, 32.794933], [-96.745363, 32.794262], [-96.745134, 32.793974], [-96.745306, 32.79268], [-96.743936, 32.792823], [-96.743936, 32.791864], [-96.743936, 32.791529], [-96.744051, 32.789946], [-96.744108, 32.786685], [-96.744108, 32.784719], [-96.744108, 32.784383], [-96.739943, 32.784383], [-96.737262, 32.784383], [-96.737148, 32.785007], [-96.737148, 32.785343], [-96.737148, 32.787549], [-96.733041, 32.787405], [-96.733041, 32.784575], [-96.733326, 32.781506], [-96.733441, 32.779636], [-96.735722, 32.779636], [-96.737626, 32.780059], [-96.737662, 32.780403], [-96.737662, 32.780547], [-96.738917, 32.780355], [-96.739658, 32.780355], [-96.740514, 32.780451], [-96.740955, 32.780631], [-96.742171, 32.78113], [-96.742739, 32.781362], [-96.743526, 32.781632], [-96.74485, 32.782085], [-96.745819, 32.782417], [-96.746588, 32.782468], [-96.747797, 32.782549], [-96.749413, 32.782657], [-96.750986, 32.78272], [-96.751808, 32.782753], [-96.752906, 32.782891], [-96.75409, 32.783041], [-96.755768, 32.783332], [-96.757399, 32.783616], [-96.75706, 32.783893], [-96.755345, 32.785295], [-96.752683, 32.787853], [-96.752151, 32.788364], [-96.751388, 32.787722], [-96.750732, 32.787171], [-96.750496, 32.786973], [-96.750009, 32.786589], [-96.749039, 32.785824], [-96.747715, 32.784716], [-96.746583, 32.783747], [-96.745591, 32.782897], [-96.744735, 32.782945], [-96.744792, 32.784004], [-96.744849, 32.785055], [-96.745364, 32.785501], [-96.746628, 32.786596], [-96.747471, 32.787326], [-96.748315, 32.788058], [-96.749046, 32.788691], [-96.749692, 32.789251], [-96.750439, 32.789898], [-96.749898, 32.790316], [-96.749043, 32.790976], [-96.748442, 32.79144], [-96.747611, 32.792081], [-96.74696, 32.792584], [-96.746047, 32.793351], [-96.746628, 32.793769], [-96.747245, 32.794214], [-96.747837, 32.793737], [-96.748671, 32.793063], [-96.749506, 32.792404], [-96.750033, 32.791988], [-96.750553, 32.791577], [-96.751083, 32.791082], [-96.75158, 32.790618], [-96.752081, 32.790242], [-96.752717, 32.789765], [-96.753262, 32.789357], [-96.753691, 32.789035], [-96.753987, 32.788793], [-96.754295, 32.78854], [-96.754535, 32.788343], [-96.755316, 32.787704], [-96.755316, 32.787704], [-96.756277, 32.786925], [-96.756277, 32.786925], [-96.757355, 32.786086], [-96.757969, 32.78563], [-96.758116, 32.785462], [-96.758704, 32.78479], [-96.759062, 32.78438], [-96.759162, 32.784267], [-96.759395, 32.784], [-96.76022, 32.784192], [-96.761056, 32.784386], [-96.761894, 32.784582], [-96.763103, 32.784863], [-96.763745, 32.784367], [-96.764669, 32.783653], [-96.764949, 32.783437], [-96.765214, 32.783232], [-96.765258, 32.783244], [-96.765214, 32.783568], [-96.766819, 32.784001], [-96.767577, 32.784205], [-96.768901, 32.784562], [-96.769663, 32.784767], [-96.769663, 32.784815], [-96.769663, 32.785151], [-96.769116, 32.785913], [-96.768301, 32.78705], [-96.767471, 32.788207], [-96.769264, 32.789802], [-96.76907, 32.789965], [-96.769264, 32.790138], [-96.76664, 32.792344], [-96.762704, 32.795701], [-96.759224, 32.79853], [-96.757456, 32.800112], [-96.756563, 32.800902], [-96.757522, 32.801735], [-96.757304, 32.801881], [-96.754718, 32.803612], [-96.75255, 32.805434], [-96.750268, 32.807256], [-96.747815, 32.805578]]]]
    },
    "properties": {
      "name": null,
      "holc_id": "C8",
      "holc_grade": "C",
      "area_description_data": {
        "5": "On Garland, Perry, Gurley, Ash Lane, Terry for about 3 blocks on each side of Fitzhugh is better part of area. Southeastern and southern portion worst part of area.",
        "6": "Dallas, Texas C 8",
        "31": "95",
        "32": "5",
        "33": "",
        "1a": "Level to gently rolling.",
        "1b": "Schools, churches, stores in area. All city conveniences. Adequate transportation. Parks in area.",
        "1c": "Mixed type of construction - encroachment of commercial and industrial establishments.",
        "1d": "85",
        "1e": "Static",
        "2a": "Clerical, professional,small merchants, skilled mechanics, etc.",
        "2b": "900-3000",
        "2c": "No -",
        "2d": "No ",
        "2e": "None",
        "2f": "Few",
        "2g": "  Yes",
        "3a": "Singles 4/6 rs. Apts.4/8 units, 3/5 rs. ",
        "3b": "Frame Frame & brick ",
        "3c": "20 15 ",
        "3d": "Fair Fair ",
        "3e": "95 85 ",
        "3f": "55 15 ",
        "3g": "50 - 3500 None ",
        "3h": "1500-4000 4000-10,000 ",
        "3i": "1936 1250-3500 85 3000-7000 73  ",
        "3j": "1938 1250-3000 85 3000-7000 73  ",
        "3k": "Poor None ",
        "3l": "Poor None ",
        "3m": "12.50-40 17.50-35 ",
        "3n": "1936 10-35 84 15-27.50 82  ",
        "3o": "1938 10-35 84 15-27.50 82  ",
        "3p": "to 25 - fair to 25 - fair ",
        "3q": "Fair Fair ",
        "4a": "Ample",
        "4b": "Ample"
      }
    }
  }, {
    "type": "Feature",
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [[[[-96.785749, 32.821974], [-96.783353, 32.818522], [-96.782612, 32.818091], [-96.777421, 32.818043], [-96.777421, 32.815694], [-96.774626, 32.815694], [-96.774683, 32.811139], [-96.772458, 32.809413], [-96.776451, 32.806345], [-96.77377, 32.804044], [-96.771659, 32.802126], [-96.769663, 32.800256], [-96.76818, 32.799249], [-96.766411, 32.800639], [-96.765157, 32.801598], [-96.763388, 32.802749], [-96.761848, 32.804092], [-96.760821, 32.804859], [-96.759623, 32.803708], [-96.75854, 32.802895], [-96.758026, 32.802509], [-96.757522, 32.802071], [-96.757304, 32.801881], [-96.757522, 32.801735], [-96.756563, 32.800902], [-96.757456, 32.800112], [-96.759224, 32.79853], [-96.762704, 32.795701], [-96.76664, 32.792344], [-96.769264, 32.790138], [-96.770519, 32.790857], [-96.771831, 32.789659], [-96.773656, 32.791145], [-96.776166, 32.793399], [-96.778048, 32.794933], [-96.778961, 32.794262], [-96.780216, 32.792919], [-96.783696, 32.795701], [-96.786404, 32.797831], [-96.786034, 32.798146], [-96.784038, 32.799824], [-96.786662, 32.801982], [-96.788487, 32.803708], [-96.790084, 32.804763], [-96.791282, 32.806009], [-96.792822, 32.807256], [-96.794077, 32.808407], [-96.795218, 32.809461], [-96.795846, 32.809893], [-96.795561, 32.810612], [-96.798641, 32.811811], [-96.798092, 32.81254], [-96.797557, 32.813249], [-96.797114, 32.814118], [-96.796873, 32.814591], [-96.796131, 32.815838], [-96.795623, 32.816731], [-96.794933, 32.817947], [-96.794191, 32.819577], [-96.793336, 32.821255], [-96.792968, 32.821873], [-96.792594, 32.822501], [-96.791853, 32.823124], [-96.791282, 32.822932], [-96.789229, 32.822309], [-96.787403, 32.821782], [-96.786776, 32.82322], [-96.788031, 32.823651], [-96.789526, 32.824019], [-96.79037, 32.824227], [-96.788373, 32.826], [-96.787118, 32.827199], [-96.785631, 32.828478], [-96.784722, 32.82926], [-96.783739, 32.830022], [-96.782498, 32.830985], [-96.7813, 32.83228], [-96.780216, 32.833142], [-96.779246, 32.834053], [-96.779474, 32.833238], [-96.780444, 32.831752], [-96.781129, 32.831321], [-96.781471, 32.830458], [-96.781699, 32.829739], [-96.782041, 32.828828], [-96.782612, 32.827918], [-96.783068, 32.827151], [-96.783296, 32.826432], [-96.784266, 32.82461], [-96.785749, 32.821974]]]]
    },
    "properties": {
      "name": null,
      "holc_id": "C9",
      "holc_grade": "C",
      "area_description_data": {
        "5": "Better apartments on N. Fitzhugh,Ross, Bryan, Live Oak, Mosher, Bennett, Garrett & Tremint. Older apartments on Carroll, Annex, Ashby & Peak. Best cottage area on Henderson, Garrett, Belmont, Milam & Alcott. Larger 2 story houses scattered. On N. Fitzhugh, across from Mission, an apartment project of 96 units consisting of about 12 seperate buildings, financed by FHA insured mortgage, has just been completed and opened for occupancy this year.",
        "6": "Dallas, Texas C 9",
        "31": "60",
        "32": "30",
        "33": "10",
        "1a": "Level - to slightly rolling.",
        "1b": "High schools, grade schools, churches, stores in area. Adequate transportation. All city convenciences. Park in area.",
        "1c": "Railroad tracks through part of area. Old properties. 2 Industrial plants - many large apartments houses of varying degrees of desirability. No restrictions except zoning.",
        "1d": "95",
        "1e": "Static",
        "2a": "laborers, clerical, professional and business men",
        "2b": "600-4500",
        "2c": "No -",
        "2d": "Yes 3% ",
        "2e": "lower grade slightly",
        "2f": "Few",
        "2g": "  Yes",
        "3a": "Singles 4/7 rs. Apts.4/20 units 3/5 rs. Singles 2 sty.7/12 rs.",
        "3b": "Frame, few brick Frame & brick Frame & brick",
        "3c": "25 20 25",
        "3d": "Poor to fair Fair - good Poor to fair",
        "3e": "95 85 95",
        "3f": "35 10 30",
        "3g": "None 8 to 40,000 None",
        "3h": "2000-5500 6000-45,000 2500-6500",
        "3i": "1936 1500-4000 74 5000-40,000 86 2000-5500 82",
        "3j": "1938 1500-4000 74 5000-40,000 86 2000-5500 82",
        "3k": "None Poor None",
        "3l": "None Poor None",
        "3m": "22.50-55 25-65 30-70",
        "3n": "1936 17.50-45 80 17.50-60 81 25-60 85",
        "3o": "1938 17.50-45 80 17.50-60 81 25-60 85",
        "3p": "to 40 - fair to 45 - fair to 50 - fair",
        "3q": "Fair Fair Fair",
        "4a": "Ample",
        "4b": "Ample"
      }
    }
  }, {
    "type": "Feature",
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [[[[-96.824733, 32.777369], [-96.823129, 32.775521], [-96.822416, 32.773522], [-96.822119, 32.773223], [-96.821762, 32.772074], [-96.822178, 32.771974], [-96.821703, 32.770775], [-96.821168, 32.769426], [-96.821109, 32.768876], [-96.820871, 32.768176], [-96.820574, 32.767327], [-96.81998, 32.766528], [-96.82086, 32.766542], [-96.821932, 32.766559], [-96.82307, 32.766578], [-96.822891, 32.767527], [-96.827051, 32.767827], [-96.827051, 32.771474], [-96.831091, 32.771524], [-96.831032, 32.772873], [-96.831448, 32.772673], [-96.832161, 32.772373], [-96.832814, 32.772223], [-96.833527, 32.771674], [-96.834062, 32.771174], [-96.834775, 32.770625], [-96.835369, 32.770175], [-96.835964, 32.769775], [-96.837093, 32.769126], [-96.838043, 32.768526], [-96.838994, 32.768077], [-96.839054, 32.771074], [-96.840836, 32.771174], [-96.843807, 32.771124], [-96.847135, 32.770974], [-96.848501, 32.770924], [-96.849511, 32.770775], [-96.850938, 32.770525], [-96.851829, 32.770475], [-96.852839, 32.770325], [-96.854324, 32.770225], [-96.857295, 32.770225], [-96.859851, 32.770175], [-96.859791, 32.772373], [-96.860029, 32.775421], [-96.862465, 32.775921], [-96.864604, 32.77622], [-96.866684, 32.77642], [-96.867337, 32.77642], [-96.86704, 32.786262], [-96.864069, 32.785912], [-96.861574, 32.785712], [-96.858246, 32.785363], [-96.856404, 32.785163], [-96.854027, 32.785013], [-96.851056, 32.784863], [-96.848382, 32.784713], [-96.844817, 32.784413], [-96.841846, 32.784064], [-96.839826, 32.783914], [-96.837687, 32.783664], [-96.834835, 32.783314], [-96.831626, 32.783015], [-96.82919, 32.782715], [-96.827645, 32.781166], [-96.826575, 32.780217], [-96.8261, 32.779468], [-96.825268, 32.778319], [-96.824733, 32.777369]]]]
    },
    "properties": {
      "name": "Oak Cliff",
      "holc_id": "D1",
      "holc_grade": "D",
      "area_description_data": {
        "5": "10% type of mentioned above is located on West Commerce West of Edgefield - the reason for the increase in value shown is that since 1929 a 4 Lane highway to Fort Worth has been opened just South of this section and has resulted in a better type of people moving into this particular section,modernization and repair of properties. Part of area North of railroad and east of Edgefield contains the lower grade of population and cheaper, poorly maintained properties.",
        "6": "Oak Cliff Dallas, Texas D 1",
        "31": "90",
        "32": "10",
        "33": "",
        "1a": "Level to rolling.",
        "1b": "All city conveniences, school and churches in area.",
        "1c": "Type of population (some criminal elements) cement plant-fertilizer factory and many other small industrial plants, many unpaved strets, inadequate transportation, very poor construction",
        "1d": "40",
        "1e": "Static",
        "2a": "Unskilled laborers",
        "2b": "600-1000",
        "2c": "5 Italians & Mexicans",
        "2d": "Yes 10% ",
        "2e": "already there",
        "2f": "Many",
        "2g": "  Yes",
        "3a": "Singles 3/4 rs. Singles 4/5 rs. ",
        "3b": "Frame Frame ",
        "3c": "20 15 ",
        "3d": "Poor Fair ",
        "3e": "95 98 ",
        "3f": "50 70 ",
        "3g": "6 to 1000 4 to 1500 ",
        "3h": "500-1250 750-1500 ",
        "3i": "1936 300-1000 70 1400-2000 160  ",
        "3j": "1938 300-1000 70 1400-2000 160  ",
        "3k": "None Poor ",
        "3l": "None Poor ",
        "3m": "5-15 7.50-15 ",
        "3n": "1936 3.50-12.50 77 12.50-20 150  ",
        "3o": "1938 3.50-12.50 77 12.50-20 150  ",
        "3p": "to 10 - Fair to 17.50 - Fair ",
        "3q": "Fair Fair ",
        "4a": "Limited",
        "4b": "Limited"
      }
    }
  }, {
    "type": "Feature",
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [[[[-96.833576, 32.755419], [-96.835121, 32.755269], [-96.835358, 32.756618], [-96.833576, 32.756668], [-96.833576, 32.755419]]]]
    },
    "properties": {
      "name": "Oak Cliff",
      "holc_id": "D2",
      "holc_grade": "D",
      "area_description_data": {
        "5": "This is a small are of negro houses - occupants largely employed as domestics in adjoining areas to west. No expansion of area.",
        "6": "Oak Cliff  Dallas, Texas D 2",
        "31": "100",
        "32": "",
        "33": "",
        "1a": "Slightly rolling",
        "1b": "All city conveniences",
        "1c": "Type of population - negro area.",
        "1d": "70",
        "1e": "Static",
        "2a": "Laborers, domestics",
        "2b": "300-600",
        "2c": "No -",
        "2d": "Yes 100 % ",
        "2e": "-",
        "2f": "Some",
        "2g": "  Yes",
        "3a": "Singles 3/4 rs.  ",
        "3b": "Frame  ",
        "3c": "25  ",
        "3d": "Poor  ",
        "3e": "98  ",
        "3f": "25  ",
        "3g": "None  ",
        "3h": "750-1500  ",
        "3i": "1936 500-1250 75    ",
        "3j": "1938 500-1250 75    ",
        "3k": "None  ",
        "3l": "None  ",
        "3m": "7.50-12.00  ",
        "3n": "1936 6.00-10.00 82    ",
        "3o": "1938 6.00-10.00 82    ",
        "3p": "to 10.00 - Good  ",
        "3q": "Fair  ",
        "4a": "None",
        "4b": "None"
      }
    }
  }, {
    "type": "Feature",
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [[[[-96.802262, 32.739726], [-96.802737, 32.738377], [-96.80446, 32.738477], [-96.806659, 32.738477], [-96.808738, 32.738527], [-96.808857, 32.740176], [-96.808857, 32.740976], [-96.809808, 32.741026], [-96.810759, 32.741126], [-96.811709, 32.741426], [-96.812763, 32.741682], [-96.813017, 32.742325], [-96.813545, 32.742976], [-96.813017, 32.743075], [-96.812957, 32.746424], [-96.813076, 32.748023], [-96.811947, 32.749022], [-96.811604, 32.749448], [-96.811289, 32.749837], [-96.810818, 32.750422], [-96.810402, 32.751321], [-96.81165, 32.751521], [-96.810937, 32.752371], [-96.810699, 32.75377], [-96.81064, 32.754619], [-96.810521, 32.755369], [-96.810699, 32.756068], [-96.811056, 32.757268], [-96.811709, 32.758567], [-96.812304, 32.759416], [-96.812482, 32.760016], [-96.812541, 32.761515], [-96.811175, 32.760516], [-96.80957, 32.759217], [-96.807431, 32.757668], [-96.805648, 32.756019], [-96.803688, 32.754519], [-96.800538, 32.752271], [-96.798399, 32.750871], [-96.797449, 32.750172], [-96.796617, 32.749972], [-96.796201, 32.749022], [-96.795904, 32.747923], [-96.795607, 32.746524], [-96.795785, 32.745174], [-96.796438, 32.745024], [-96.79727, 32.744674], [-96.797983, 32.744225], [-96.798875, 32.743775], [-96.799409, 32.743175], [-96.800182, 32.742875], [-96.800717, 32.742425], [-96.80137, 32.741726], [-96.801905, 32.740676], [-96.802262, 32.739726]]]]
    },
    "properties": {
      "name": "Oak Cliff",
      "holc_id": "D3",
      "holc_grade": "D",
      "area_description_data": {
        "5": "Cheaper properties location north of Hutchins. North of railroad east of Cliff and south of Hutchins and west of Cliff St. includes the larger better properties in the area, apartments and 2 stories.",
        "6": "Oak Cliff Dallas, Texas D 3",
        "31": "40",
        "32": "30",
        "33": "25 About 5% of area is 2 sty frames & apts. 4- fam. converted 3/4 rm. units.",
        "1a": "Rolling.",
        "1b": "Has all city conveniences, schools and churches in area. Adequate transportation.",
        "1c": "Mixtuer of population - proximity of river. Cemetery. Packing House in area, many cheap stores, street car barn in area, many unpaved streets.",
        "1d": "85",
        "1e": "Static",
        "2a": "Unskilled laborers, domestics, Packing house employees, street car employees",
        "2b": "500-1500",
        "2c": "No -",
        "2d": "Yes 35% ",
        "2e": "None",
        "2f": "Some",
        "2g": "  Yes",
        "3a": "Singles 4/7 rs. Singles 3/5 rs. Singles 3/4 rs. ",
        "3b": "Frame Frame Frame",
        "3c": "30 30 30",
        "3d": "Poor to fair Poor Poor",
        "3e": "95 95 95",
        "3f": "40 40 20",
        "3g": "None 15 to 2000 None",
        "3h": "2000-5000 900-3000 450-1250",
        "3i": "1936 1500-4000 78 500-2000 61 350-1000 79",
        "3j": "1938 1500-4000 78 500-2000 61 350-1000 79",
        "3k": "None None None",
        "3l": "Poor Poor Poor",
        "3m": "20-50 18-20 6-17.50",
        "3n": "1936 15-40 78 15-20 78 5-15.00 85",
        "3o": "1938 15-40 78 15-20 78 5-15.00 85",
        "3p": "to 30 - fair to 15 - fair to 10 - fair",
        "3q": "Fair Fair Fair",
        "4a": "Limited",
        "4b": "Limited"
      }
    }
  }, {
    "type": "Feature",
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [[[[-96.745087, 32.75321], [-96.745895, 32.752466], [-96.747083, 32.751227], [-96.748034, 32.750068], [-96.749603, 32.748268], [-96.750411, 32.747109], [-96.751267, 32.74591], [-96.75217, 32.74471], [-96.753073, 32.743431], [-96.753881, 32.742391], [-96.753833, 32.741392], [-96.753691, 32.740192], [-96.753691, 32.739272], [-96.753501, 32.737993], [-96.751837, 32.737953], [-96.750268, 32.738193], [-96.748605, 32.738313], [-96.748462, 32.737433], [-96.748319, 32.735954], [-96.748272, 32.734714], [-96.748319, 32.734274], [-96.749555, 32.734274], [-96.751837, 32.734034], [-96.753311, 32.733914], [-96.754737, 32.733714], [-96.755925, 32.733594], [-96.756828, 32.733554], [-96.757066, 32.734514], [-96.757161, 32.735754], [-96.757351, 32.736793], [-96.757589, 32.737993], [-96.757779, 32.739872], [-96.757969, 32.741911], [-96.758321, 32.742943], [-96.757922, 32.743519], [-96.758036, 32.74443], [-96.758321, 32.745342], [-96.758777, 32.746349], [-96.759462, 32.747165], [-96.759861, 32.747837], [-96.76026, 32.7487], [-96.759747, 32.74918], [-96.758834, 32.749948], [-96.757922, 32.750523], [-96.757351, 32.751243], [-96.756039, 32.752154], [-96.755241, 32.752586], [-96.754556, 32.75321], [-96.753871, 32.753738], [-96.753472, 32.754169], [-96.752674, 32.754937], [-96.751704, 32.755896], [-96.750791, 32.75652], [-96.75005, 32.757096], [-96.749251, 32.756616], [-96.747654, 32.755225], [-96.746285, 32.754121], [-96.745087, 32.75321]]]]
    },
    "properties": {
      "name": null,
      "holc_id": "D4",
      "holc_grade": "D",
      "area_description_data": {
        "5": "This is a typical nego area, on the outskirts of the city. Sale demand is largely for investment and when prices are bargains.",
        "6": "Dallas, Texas D 4",
        "31": "80",
        "32": "20",
        "33": "",
        "1a": "Level.",
        "1b": "Schools and stores in area, has city conveniences.",
        "1c": "Distance from center of city - type of population, unpaved streets, cheap houses.",
        "1d": "60",
        "1e": "Stati",
        "2a": "Negro laborers",
        "2b": "600-",
        "2c": "None -",
        "2d": "Yes 100% ",
        "2e": "None",
        "2f": "Many",
        "2g": "  Yes",
        "3a": "Singles 2/4 rs. Singles 3/5 rs. ",
        "3b": "Frame Frame ",
        "3c": "25 25 ",
        "3d": "Poor Fair ",
        "3e": "98 98 ",
        "3f": "55 80 ",
        "3g": "None 10 to 1200 ",
        "3h": "500-1200 1000-1850 ",
        "3i": "1936 300-900 68 850-1600 86  ",
        "3j": "1938 300-900 68 850-1600 86  ",
        "3k": "to 600 - Fair for inv. None ",
        "3l": "Fair None ",
        "3m": "5-15 10-20 ",
        "3n": "1936 4-12 80 8-16 80  ",
        "3o": "1938 4-12 80 8-16 80  ",
        "3p": "to 10 - fair to 15 - fair ",
        "3q": "Fair Fair ",
        "4a": "None",
        "4b": "None"
      }
    }
  }, {
    "type": "Feature",
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [[[[-96.76022, 32.784192], [-96.759395, 32.784], [-96.759162, 32.784267], [-96.758435, 32.784052], [-96.757399, 32.783952], [-96.75706, 32.783893], [-96.757399, 32.783616], [-96.755768, 32.783332], [-96.75409, 32.783041], [-96.752906, 32.782891], [-96.751808, 32.782753], [-96.750986, 32.78272], [-96.749413, 32.782657], [-96.747797, 32.782549], [-96.746588, 32.782468], [-96.745819, 32.782417], [-96.74485, 32.782085], [-96.743526, 32.781632], [-96.742739, 32.781362], [-96.742171, 32.78113], [-96.740955, 32.780631], [-96.740514, 32.780451], [-96.739658, 32.780355], [-96.738917, 32.780355], [-96.737662, 32.780547], [-96.737662, 32.780403], [-96.737626, 32.780059], [-96.737443, 32.778297], [-96.735447, 32.777769], [-96.734534, 32.777242], [-96.73402, 32.776426], [-96.734135, 32.775419], [-96.734477, 32.774172], [-96.735218, 32.772925], [-96.735618, 32.771726], [-96.736074, 32.770719], [-96.736587, 32.769567], [-96.737557, 32.768752], [-96.737899, 32.768033], [-96.738013, 32.766258], [-96.73944, 32.766258], [-96.74058, 32.766306], [-96.741949, 32.766402], [-96.742862, 32.766402], [-96.744231, 32.766402], [-96.745429, 32.766498], [-96.74657, 32.766402], [-96.747768, 32.766594], [-96.748624, 32.766737], [-96.74965, 32.766881], [-96.750848, 32.766833], [-96.751932, 32.766785], [-96.753016, 32.766833], [-96.754556, 32.767073], [-96.756153, 32.767553], [-96.756895, 32.767985], [-96.755925, 32.768608], [-96.754955, 32.769136], [-96.754043, 32.769759], [-96.753244, 32.770335], [-96.751875, 32.771678], [-96.750563, 32.772829], [-96.749365, 32.773884], [-96.747939, 32.774891], [-96.74965, 32.775899], [-96.750677, 32.776762], [-96.751989, 32.777913], [-96.753814, 32.779112], [-96.753187, 32.779592], [-96.752845, 32.780071], [-96.753301, 32.780263], [-96.7541, 32.780647], [-96.754898, 32.780934], [-96.755982, 32.78127], [-96.756781, 32.781462], [-96.757922, 32.781894], [-96.758606, 32.78199], [-96.759405, 32.782133], [-96.76026, 32.782277], [-96.761515, 32.782661], [-96.762542, 32.782757], [-96.764253, 32.783093], [-96.764949, 32.783437], [-96.764669, 32.783653], [-96.763745, 32.784367], [-96.763103, 32.784863], [-96.761894, 32.784582], [-96.761056, 32.784386], [-96.76022, 32.784192]]]]
    },
    "properties": {
      "name": null,
      "holc_id": "D5",
      "holc_grade": "D",
      "area_description_data": {
        "5": "East end of Spring, Jamacia, Collins, Baldwin, Mckenzie, Fleetwood, Caldwell are best streets. Frazier, Gray, Troy, Italy, Duckett, are worst streets.",
        "6": "Dallas, Texas D 5",
        "31": "65",
        "32": "35",
        "33": "",
        "1a": "Level.",
        "1b": "Schools, churches, and stores in area - has city conveniences. Adequate transportation.",
        "1c": "Cheap construction - type of population - unpaved streets. Railroad tracks through area - with some industrial plants located along the tracks.",
        "1d": "60",
        "1e": "Static",
        "2a": "Negro laborers",
        "2b": "600-750",
        "2c": "None ",
        "2d": "Yes 100% ",
        "2e": "None",
        "2f": "Many",
        "2g": "  Yes",
        "3a": "Singles 4/5 rs. Singles 3/4 rs. ",
        "3b": "Frame Frame ",
        "3c": "25 25 ",
        "3d": "Poor Poor ",
        "3e": "95 95 ",
        "3f": "65 20 ",
        "3g": "6 to 1200 None ",
        "3h": "1000-2500 600-1250 ",
        "3i": "1936 800-2000 80 400-1000 73  ",
        "3j": "1938 800-2000 80 400-1000 73  ",
        "3k": "None None ",
        "3l": "Poor Poor ",
        "3m": "8-25 5-12 ",
        "3n": "1936 6-20 88 4-10 83  ",
        "3o": "1938 6-29 88 4-10 83  ",
        "3p": "to 17.50 fair to 8 - fair ",
        "3q": "Fair Fair ",
        "4a": "Limited",
        "4b": "Limited"
      }
    }
  }, {
    "type": "Feature",
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [[[[-96.77045, 32.751941], [-96.772589, 32.750142], [-96.773718, 32.751191], [-96.774728, 32.75224], [-96.775857, 32.75334], [-96.776808, 32.754289], [-96.777877, 32.755239], [-96.778709, 32.755938], [-96.77966, 32.756588], [-96.780848, 32.757587], [-96.781858, 32.758337], [-96.78275, 32.759037], [-96.7837, 32.759736], [-96.784829, 32.760236], [-96.785602, 32.760686], [-96.785721, 32.761235], [-96.785661, 32.762035], [-96.78578, 32.762834], [-96.786077, 32.763833], [-96.786612, 32.764633], [-96.787503, 32.765332], [-96.788454, 32.765582], [-96.788989, 32.765982], [-96.78988, 32.766632], [-96.792376, 32.768031], [-96.794099, 32.76908], [-96.795525, 32.769879], [-96.797842, 32.771328], [-96.796951, 32.772277], [-96.79505, 32.773676], [-96.793267, 32.775125], [-96.792079, 32.776174], [-96.79095, 32.776324], [-96.789583, 32.776524], [-96.788216, 32.776574], [-96.786315, 32.776674], [-96.784651, 32.776774], [-96.7837, 32.777573], [-96.782215, 32.778822], [-96.783581, 32.780221], [-96.784473, 32.78107], [-96.782868, 32.78132], [-96.781442, 32.78147], [-96.779779, 32.78172], [-96.778887, 32.782019], [-96.778174, 32.782569], [-96.777699, 32.783069], [-96.777105, 32.783468], [-96.776926, 32.783818], [-96.776451, 32.784317], [-96.775441, 32.785466], [-96.775293, 32.786385], [-96.774668, 32.786216], [-96.772292, 32.785566], [-96.769663, 32.785151], [-96.769855, 32.784168], [-96.770034, 32.783218], [-96.770271, 32.782019], [-96.770984, 32.780121], [-96.771341, 32.779022], [-96.772826, 32.777673], [-96.774847, 32.775925], [-96.775916, 32.774726], [-96.776867, 32.774126], [-96.777342, 32.773477], [-96.778293, 32.772877], [-96.779303, 32.771178], [-96.780195, 32.769879], [-96.781383, 32.76858], [-96.782512, 32.766931], [-96.783403, 32.765532], [-96.78275, 32.764683], [-96.784116, 32.763534], [-96.783225, 32.762834], [-96.782155, 32.761685], [-96.780373, 32.760286], [-96.779125, 32.759286], [-96.777758, 32.758137], [-96.77657, 32.757138], [-96.774966, 32.755838], [-96.773064, 32.754389], [-96.7714, 32.75309], [-96.77045, 32.751941]]]]
    },
    "properties": {
      "name": null,
      "holc_id": "D6",
      "holc_grade": "D",
      "area_description_data": {
        "5": "Portion of area surrounding city park is best part of area. Negro population in northeastern part and southern tip. Harwood Park Row, Northeast end of Beaumont, Pocahontas, Gayne are better streets.",
        "6": "Dallas, Texas D 6",
        "31": "60",
        "32": "30",
        "33": "10",
        "1a": "Level.",
        "1b": "Park in area, schools, churches and stores. Close to business center. All city conveniences. Adequate transportation.",
        "1c": "Encroachment of commercial and industrial establishments. Railroad tracks through area. Mixed type of population and construction.",
        "1d": "95",
        "1e": "Static",
        "2a": "Laborers, factor workers, clerical",
        "2b": "400-1500",
        "2c": "20 Jewish-Italian-Greeks",
        "2d": "Yes 50% ",
        "2e": "lower grade slowly",
        "2f": "Many",
        "2g": "  Yes",
        "3a": "Singles 4/6 rs. Singles 8/12 rs. & includes large old houses made into duplexes Singles 3/4 rs.",
        "3b": "Frame Frame Frame",
        "3c": "35 35 35",
        "3d": "Poor Poor Poor",
        "3e": "90 80 90",
        "3f": "30 10 20",
        "3g": "None None None",
        "3h": "1000-3000 3000-10,000 9,002,000",
        "3i": "1936 800-220 78 2000-6000 63 600-1500 71",
        "3j": "1938 800-2250 78 2000-6000 63 600-1500 71",
        "3k": "None None None",
        "3l": "None None None",
        "3m": "12.50-35 20-40 8-20",
        "3n": "1936 7.50-27.50 70 17.50-32.50 84 5-15 69",
        "3o": "1938 7.50-27.50 70 17.50-32.50 84 5-15 69",
        "3p": "to 17.50-poor to 25.00 poor to 12.00 poor",
        "3q": "poor poor poor",
        "4a": "limited",
        "4b": "limited"
      }
    }
  }, {
    "type": "Feature",
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [[[[-96.783696, 32.795701], [-96.780216, 32.792919], [-96.778961, 32.794262], [-96.778048, 32.794933], [-96.776166, 32.793399], [-96.773656, 32.791145], [-96.771831, 32.789659], [-96.770519, 32.790857], [-96.769264, 32.790138], [-96.76907, 32.789965], [-96.769264, 32.789802], [-96.767471, 32.788207], [-96.768301, 32.78705], [-96.769116, 32.785913], [-96.769663, 32.785151], [-96.772292, 32.785566], [-96.774668, 32.786216], [-96.775293, 32.786385], [-96.77651, 32.786715], [-96.778293, 32.787015], [-96.779481, 32.787065], [-96.781026, 32.786715], [-96.781799, 32.787215], [-96.782809, 32.787914], [-96.784354, 32.789213], [-96.785839, 32.788314], [-96.786731, 32.787614], [-96.788513, 32.786565], [-96.78887, 32.787015], [-96.791187, 32.789013], [-96.79499, 32.785766], [-96.79786, 32.788272], [-96.796844, 32.789131], [-96.795397, 32.790264], [-96.794762, 32.790761], [-96.793612, 32.791748], [-96.79191, 32.793207], [-96.789856, 32.794885], [-96.787525, 32.796875], [-96.786404, 32.797831], [-96.783696, 32.795701]]]]
    },
    "properties": {
      "name": null,
      "holc_id": "D7",
      "holc_grade": "D",
      "area_description_data": {
        "5": "The entire area is a transition from residential to industrial, commercial and apartment houses. As a residential area the portion the greatest distance from the business center is the better part.",
        "6": "Dallas, Texas D 7",
        "31": "60",
        "32": "30",
        "33": "10",
        "1a": "Level.",
        "1b": "Close to business center. Schools, churches, stores in area. All city conveniences. Adequate transportation. Small park in area.",
        "1c": "Encroachment of commercial and industrial establishments, junk yards and second hand auto parts stores. Cheaply constructed houses. Type of population.",
        "1d": "100",
        "1e": "Static",
        "2a": "Laborers, factory workers, clerical, small business men",
        "2b": "600-1000",
        "2c": "5 Italians",
        "2d": "Yes 20% lower grade to east",
        "2e": "Many",
        "2f": "",
        "2g": "  Yes",
        "3a": "Singles 4/6 rs. Singles-8/12 rs. and includes duplexed and some few apt. units Singles 3/4 rs.",
        "3b": "Frame Frame Frame",
        "3c": "35 35 35",
        "3d": "Poor Fair Poor",
        "3e": "95 90 90",
        "3f": "35 25 15",
        "3g": "None None None",
        "3h": "1750-5000 2500-30,000 1000-3000",
        "3i": "1936 1500-4000 83 2000-20,000 73 500-2000 58",
        "3j": "1938 1500-4000 83 2000-20,000 73 500-2000 58",
        "3k": "None None None",
        "3l": "None None None",
        "3m": "15-45 25-55 8-25",
        "3n": "1936 12.50-35 81 20-40 76 5-20 71",
        "3o": "1938 12.50-35 81 20-40 76 5-20 71",
        "3p": "to 30 - Fair to 35 - Fair to 15 - Fair",
        "3q": "Fair Fair Fair",
        "4a": "Limited",
        "4b": "Limited"
      }
    }
  }, {
    "type": "Feature",
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [[[[-96.794762, 32.790761], [-96.795397, 32.790264], [-96.796844, 32.789131], [-96.79726, 32.788779], [-96.79786, 32.788272], [-96.800238, 32.786158], [-96.801208, 32.786973], [-96.803318, 32.788939], [-96.803775, 32.789371], [-96.804687, 32.789467], [-96.806741, 32.787884], [-96.807768, 32.788508], [-96.808566, 32.788939], [-96.809251, 32.789563], [-96.810449, 32.79057], [-96.808852, 32.791577], [-96.807996, 32.79244], [-96.809251, 32.793495], [-96.810278, 32.794166], [-96.811647, 32.795461], [-96.81273, 32.796276], [-96.813358, 32.797187], [-96.812217, 32.798194], [-96.811133, 32.799057], [-96.809878, 32.799824], [-96.808966, 32.800352], [-96.807368, 32.800927], [-96.806171, 32.801694], [-96.8056, 32.800543], [-96.805315, 32.799345], [-96.803318, 32.797666], [-96.801949, 32.796516], [-96.80058, 32.795509], [-96.798127, 32.793303], [-96.79596, 32.791577], [-96.794782, 32.790775], [-96.794762, 32.790761]]]]
    },
    "properties": {
      "name": null,
      "holc_id": "D8",
      "holc_grade": "D",
      "area_description_data": {
        "5": "This area adjoins commercial and industrial section. Almost no sales as properties are being held as future business and industrial sites.",
        "6": "Dallas, Texas D 8",
        "31": "100",
        "32": "",
        "33": "",
        "1a": "Level to rolling.",
        "1b": "Close to business center. Schools, churches, stores in area. Adequate transportation.",
        "1c": "Type of population. Old cheap houses predominate. Encroachment of commercial and industrial establishments.",
        "1d": "95",
        "1e": "Static",
        "2a": "Common laborers",
        "2b": "300-750",
        "2c": "50 Mexican",
        "2d": "Yes 20% ",
        "2e": "None",
        "2f": "Many",
        "2g": "  Yes",
        "3a": "Singles 3/7 rms.  ",
        "3b": "Frame  ",
        "3c": "40  ",
        "3d": "Poor  ",
        "3e": "95  ",
        "3f": "10  ",
        "3g": "None  ",
        "3h": "1000-2000  ",
        "3i": "1936 500-1250 56    ",
        "3j": "1938 500-1250 56    ",
        "3k": "None  ",
        "3l": "None  ",
        "3m": "5-20  ",
        "3n": "1936 3-15 68    ",
        "3o": "1938 3-15 68    ",
        "3p": "to 12 fair  ",
        "3q": "Fair  ",
        "4a": "None",
        "4b": "None"
      }
    }
  }, {
    "type": "Feature",
    "geometry": {
      "type": "MultiPolygon",
      "coordinates": [[[[-96.837601, 32.843495], [-96.830243, 32.843734], [-96.830243, 32.83851], [-96.830471, 32.836977], [-96.831498, 32.836689], [-96.832353, 32.836306], [-96.833494, 32.836018], [-96.835377, 32.833909], [-96.837031, 32.835922], [-96.838457, 32.837648], [-96.839997, 32.839277], [-96.838457, 32.840619], [-96.836689, 32.84244], [-96.837601, 32.843495]]]]
    },
    "properties": {
      "name": null,
      "holc_id": "D9",
      "holc_grade": "D",
      "area_description_data": {
        "5": "An area occupied exclusively by negroes with vacant property on all sides. New plant of Coca Cola Bottling Company being constructed adjoining on south. Very little likelihood of any chance in the area in the near future.",
        "6": "Dallas, Texas D 9",
        "31": "60",
        "32": "40",
        "33": "",
        "1a": "Level.",
        "1b": "Schools and stores in area, city conveniences.",
        "1c": "Inadequate transportation. Distance to principal business center. Unpaved streets. Mixed construction. Large Cocao Cola plant being constructed adjoining area on south.",
        "1d": "70",
        "1e": "Static",
        "2a": "Negro laborers and domestics",
        "2b": "400-750",
        "2c": "None -",
        "2d": "Yes 100% ",
        "2e": "None",
        "2f": "Some",
        "2g": "  Yes",
        "3a": "Singles 4/5 rs. Singles 3/4 rs. ",
        "3b": "Frame Frame ",
        "3c": "20 20 ",
        "3d": "Fair to poor Poor ",
        "3e": "95 95 ",
        "3f": "35 35 ",
        "3g": "None None ",
        "3h": "1500-2750 750-1750 ",
        "3i": "1936 1250-2250 83 500-1500 76  ",
        "3j": "1938 1250-2250 83 500-1500 76  ",
        "3k": "Poor Poor ",
        "3l": "Poor Poor ",
        "3m": "15-27.50 7.50-17.50 ",
        "3n": "1936 12.50-22.50 83 5.00-15.00 76  ",
        "3o": "1938 12.50-22.50 83 5.00-15.00 76  ",
        "3p": "to 17.50 fair to 12.50 fair ",
        "3q": "Fair Fair ",
        "4a": "Limited",
        "4b": "Limited"
      }
    }
  }]
};